/**
 * Generated by '@kontent-ai/model-generator@6.5.1'
 */
export const contentTypes = {
    /**
     * Accordion
     */
    accordion: {
        codename: 'accordion',
        id: '3ffb67ef-f9b4-4bcc-a740-d476beeea96a',
        externalId: undefined,
        name: 'Accordion',
        elements: {
            /**
             * Items (modular_content)
             */
            items: {
                codename: 'items',
                id: 'ac7c21b2-de25-4628-8060-5eba0208e412',
                externalId: undefined,
                name: 'Items',
                required: false,
                type: 'modular_content'
            },

            /**
             * Title (modular_content)
             */
            title: {
                codename: 'title',
                id: '729737dc-d567-4706-85d9-7362c687c99f',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'modular_content'
            }
        }
    },

    /**
     * Accordion Item
     */
    accordion_item: {
        codename: 'accordion_item',
        id: 'c71df01d-cf4f-4771-a916-d42c35fbdac4',
        externalId: undefined,
        name: 'Accordion Item',
        elements: {
            /**
             * Description (rich_text)
             */
            description: {
                codename: 'description',
                id: '7de8a7ea-063a-4f80-9026-6455396dde13',
                externalId: undefined,
                name: 'Description',
                required: false,
                type: 'rich_text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '2a4451c6-ab01-40c9-98bb-9f5d6cccfbff',
                externalId: undefined,
                name: 'Title',
                required: true,
                type: 'text'
            }
        }
    },

    /**
     * Accreditation Form
     */
    accreditation_form: {
        codename: 'accreditation_form',
        id: 'ddcf16dd-d6ca-4acd-82cd-5cae7111acf6',
        externalId: undefined,
        name: 'Accreditation Form',
        elements: {
            /**
             * Accreditation Contact Form (modular_content)
             */
            accreditation_contact_form: {
                codename: 'accreditation_contact_form',
                id: 'd7e70323-0ddd-46eb-ba5e-871d2673b592',
                externalId: undefined,
                name: 'Accreditation Contact Form',
                required: false,
                type: 'modular_content'
            },

            /**
             * Add new record CTA label (text)
             */
            add_new_record_cta_label: {
                codename: 'add_new_record_cta_label',
                id: '018c9948-7cea-4b66-806f-040f8f5717b0',
                externalId: undefined,
                name: 'Add new record CTA label',
                required: false,
                type: 'text'
            },

            /**
             * Callback URL (modular_content)
             */
            callback_url: {
                codename: 'callback_url',
                id: '89fa3463-de2d-41c7-8099-86704299ff4a',
                externalId: undefined,
                name: 'Callback URL',
                required: true,
                type: 'modular_content'
            },

            /**
             * Columns (modular_content)
             */
            columns: {
                codename: 'columns',
                id: '5e062b18-d185-494f-ad88-13413402a70c',
                externalId: undefined,
                name: 'Columns',
                required: false,
                type: 'modular_content'
            },

            /**
             * Maximum number of Applications per role (modular_content)
             */
            maximum_number_of_applications_per_role: {
                codename: 'maximum_number_of_applications_per_role',
                id: '950a2f8d-05c8-447e-af4f-930df4f6a1a4',
                externalId: undefined,
                name: 'Maximum number of Applications per role',
                required: false,
                type: 'modular_content'
            },

            /**
             * Maximum number of Nominated for Dinner (number)
             *
             * This limit applies to all roles except Player, Caddie, and Player Children. The configured value defines the maximum total number of contacts that can be nominated for dinner.
             */
            maximum_number_of_nominated_for_dinner: {
                codename: 'maximum_number_of_nominated_for_dinner',
                id: '6209e34c-1784-4195-983b-4bc2489b960d',
                externalId: undefined,
                name: 'Maximum number of Nominated for Dinner',
                required: false,
                type: 'number'
            },

            /**
             * Roles (taxonomy)
             */
            roles: {
                codename: 'roles',
                id: 'afc087f1-cdac-424d-bc12-95bb649c1c9a',
                externalId: undefined,
                name: 'Roles',
                required: false,
                type: 'taxonomy'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '5d426645-199a-4cc4-ba55-bfa0a963845a',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Alert Bar
     */
    alert_bar: {
        codename: 'alert_bar',
        id: '30d6a4d3-90d2-43ba-8ef1-193632a699d2',
        externalId: undefined,
        name: 'Alert Bar',
        elements: {
            /**
             * Background Color (modular_content)
             */
            background_color: {
                codename: 'background_color',
                id: 'ff18d2c5-5445-4e10-9c6b-94dcb4dc44ce',
                externalId: undefined,
                name: 'Background Color',
                required: false,
                type: 'modular_content'
            },

            /**
             * Background Image (asset)
             */
            background_image: {
                codename: 'background_image',
                id: '44379c38-5156-4daf-84df-0b6d341a015a',
                externalId: undefined,
                name: 'Background Image',
                required: false,
                type: 'asset'
            },

            /**
             * Countdown (date_time)
             *
             * Leave empty to not display a countdown. Otherwise pick a date and also complete the below fields
             */
            countdown: {
                codename: 'countdown',
                id: '8465c864-1032-48db-b205-7dae633aac6b',
                externalId: undefined,
                name: 'Countdown',
                required: false,
                type: 'date_time'
            },

            /**
             * Day Label (text)
             */
            day_label: {
                codename: 'day_label',
                id: 'fadfd93a-e43d-4a2d-9542-184a4e6c8f21',
                externalId: undefined,
                name: 'Day Label',
                required: false,
                type: 'text'
            },

            /**
             * Days Label (text)
             */
            days_label: {
                codename: 'days_label',
                id: 'c058e4c8-0d0b-4339-9a9e-7b375505571e',
                externalId: undefined,
                name: 'Days Label',
                required: false,
                type: 'text'
            },

            /**
             * Hour Label (text)
             */
            hour_label: {
                codename: 'hour_label',
                id: '0cb3b643-2b08-4a04-8f71-3680ffe6149f',
                externalId: undefined,
                name: 'Hour Label',
                required: false,
                type: 'text'
            },

            /**
             * Hours Label (text)
             */
            hours_label: {
                codename: 'hours_label',
                id: 'dc43656f-a922-4e05-a32e-962bac2ba15c',
                externalId: undefined,
                name: 'Hours Label',
                required: false,
                type: 'text'
            },

            /**
             * Minute Label (text)
             */
            minute_label: {
                codename: 'minute_label',
                id: '0e610406-17b6-470a-ac62-fdacb5a688b2',
                externalId: undefined,
                name: 'Minute Label',
                required: false,
                type: 'text'
            },

            /**
             * Minutes Label (text)
             */
            minutes_label: {
                codename: 'minutes_label',
                id: '663bfaff-8027-4c5f-bd7d-c8a5db2ef671',
                externalId: undefined,
                name: 'Minutes Label',
                required: false,
                type: 'text'
            },

            /**
             * Text (rich_text)
             */
            text: {
                codename: 'text',
                id: 'b5025414-c6d3-4319-ab54-16c58d6de2ba',
                externalId: undefined,
                name: 'Text',
                required: false,
                type: 'rich_text'
            },

            /**
             * Text Color (modular_content)
             */
            text_color: {
                codename: 'text_color',
                id: 'e850646c-4696-4f40-b6e9-2c3606cd7472',
                externalId: undefined,
                name: 'Text Color',
                required: false,
                type: 'modular_content'
            }
        }
    },

    /**
     * Call Out Panel
     */
    call_out_panel: {
        codename: 'call_out_panel',
        id: '3c3340d5-c98c-4b11-b4d3-a5cd259855fa',
        externalId: undefined,
        name: 'Call Out Panel',
        elements: {
            /**
             * Background Image (asset)
             */
            background_image: {
                codename: 'background_image',
                id: '6dd37d1b-c2c3-495b-aaa4-c0b367247d3e',
                externalId: undefined,
                name: 'Background Image',
                required: false,
                type: 'asset'
            },

            /**
             * Description (rich_text)
             */
            description: {
                codename: 'description',
                id: '3c5d3918-d158-4a96-b046-89ba54711e2d',
                externalId: undefined,
                name: 'Description',
                required: false,
                type: 'rich_text'
            },

            /**
             * Icon (asset)
             *
             * Upload only black icons so their color automatically adapts to the theme
             */
            icon: {
                codename: 'icon',
                id: 'fc785ccb-6113-4d9b-bec3-6f611aa74e19',
                externalId: undefined,
                name: 'Icon',
                required: false,
                type: 'asset'
            },

            /**
             * Link (modular_content)
             */
            link: {
                codename: 'link',
                id: 'ab3b396f-8b29-44d4-a57f-ed49f07467ff',
                externalId: undefined,
                name: 'Link',
                required: false,
                type: 'modular_content'
            },

            /**
             * Theme (multiple_choice)
             */
            theme: {
                codename: 'theme',
                id: '889621fd-da20-4b9f-8e82-108f5aadce86',
                externalId: undefined,
                name: 'Theme',
                required: false,
                type: 'multiple_choice',
                options: {
                    light: {
                        name: 'light',
                        id: '34f4bc26-f261-46ee-8be3-8cdcb896790a',
                        codename: 'light',
                        externalId: undefined
                    },
                    dark: {
                        name: 'dark',
                        id: 'd122e136-0745-4cb9-bd86-cac8f510e322',
                        codename: 'dark',
                        externalId: undefined
                    },
                    water: {
                        name: 'water',
                        id: '5a244e04-abee-466f-b174-953a30f793c7',
                        codename: 'water',
                        externalId: undefined
                    },
                    wind: {
                        name: 'wind',
                        id: '89a21d60-9605-4eca-a13e-acce72c4e87d',
                        codename: 'wind',
                        externalId: undefined
                    },
                    sun: {
                        name: 'sun',
                        id: 'ba7e81da-06e4-4f4d-ab05-34d5fa7e1e16',
                        codename: 'sun',
                        externalId: undefined
                    },
                    earth: {
                        name: 'earth',
                        id: 'c9ff6e86-af67-488f-af50-f7e6b2dafec0',
                        codename: 'earth',
                        externalId: undefined
                    }
                }
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '955b8e65-16fe-4bb0-88c5-e28293be7067',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Callback URL
     */
    callback_url: {
        codename: 'callback_url',
        id: '1224f97a-df43-45f9-b25a-4eaf7b38fdc9',
        externalId: undefined,
        name: 'Callback URL',
        elements: {
            /**
             * Value (text)
             */
            value: {
                codename: 'value',
                id: '4434dce1-7f85-4eae-aaac-8534785af537',
                externalId: undefined,
                name: 'Value',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Claude Test Component
     */
    claude_test_component: {
        codename: 'claude_test_component',
        id: '74eefeb7-0e2e-432d-8e56-b473be307a5d',
        externalId: undefined,
        name: 'Claude Test Component',
        elements: {
            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '2857a8c7-edaa-4eec-b3c0-cc92e062d9e0',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Color
     */
    color: {
        codename: 'color',
        id: 'a12a6ef6-aefe-49ee-8216-d7f0d8e48ecb',
        externalId: undefined,
        name: 'Color',
        elements: {
            /**
             * Color Code (text)
             */
            color_code: {
                codename: 'color_code',
                id: '8da2d9b3-5a8e-46b7-9a20-56a7158ffcb6',
                externalId: undefined,
                name: 'Color Code',
                required: true,
                type: 'text'
            }
        }
    },

    /**
     * Content List
     */
    content_list___fixed_length: {
        codename: 'content_list___fixed_length',
        id: 'd83fad13-a3a1-4da0-b53f-eb81716bc41b',
        externalId: undefined,
        name: 'Content List',
        elements: {
            /**
             * Arrows  color (modular_content)
             */
            carousel_config__slider_arrows_color: {
                codename: 'carousel_config__slider_arrows_color',
                id: '1cef893a-158b-49f2-859d-636d68812811',
                externalId: undefined,
                name: 'Arrows: color',
                required: false,
                type: 'modular_content',

                snippetCodename: 'carousel_config'
            },

            /**
             * Arrows  size (multiple_choice)
             */
            carousel_config__slider_arrows_size: {
                codename: 'carousel_config__slider_arrows_size',
                id: '24095239-b83b-45be-94b7-49be2659708f',
                externalId: undefined,
                name: 'Arrows: size',
                required: false,
                type: 'multiple_choice',
                options: {
                    sm: {
                        name: 'sm',
                        id: 'bf6444be-bf86-49ef-8d36-06f27b56454b',
                        codename: 'sm',
                        externalId: undefined
                    },
                    lg: {
                        name: 'lg',
                        id: '5ed41f21-4bc1-48b8-8ddd-a04f6180e2a0',
                        codename: 'lg',
                        externalId: undefined
                    },
                    xl: {
                        name: 'xl',
                        id: '3f4359a4-8b9c-4e47-b4b4-edfaa5acc203',
                        codename: 'xl',
                        externalId: undefined
                    }
                },
                snippetCodename: 'carousel_config'
            },

            /**
             * Arrows  transparent background (multiple_choice)
             *
             * Default state is "No". If set to "Yes", the arrows will not have the grey circle container around them.
             */
            carousel_config__arrows__transparent_background: {
                codename: 'carousel_config__arrows__transparent_background',
                id: '055b1a91-4de8-41f7-a3d4-0b5f457badcb',
                externalId: undefined,
                name: 'Arrows: transparent background',
                required: false,
                type: 'multiple_choice',
                options: {
                    true: {
                        name: 'Yes',
                        id: '2fedd3a5-04d4-47a2-9101-86562efda62b',
                        codename: 'true',
                        externalId: undefined
                    },
                    false: {
                        name: 'No',
                        id: 'b2c262ff-0c7a-4b42-857b-d6645d10b6d5',
                        codename: 'false',
                        externalId: undefined
                    }
                },
                snippetCodename: 'carousel_config'
            },

            /**
             * Autoplay  timeout (number)
             *
             * If enabled: Set how much time the slide will auto play (in seconds) until it stops completely.
             */
            carousel_config__autoplay_timeout: {
                codename: 'carousel_config__autoplay_timeout',
                id: '8ca5dd11-0de0-4865-97aa-3c479902854b',
                externalId: undefined,
                name: 'Autoplay: timeout',
                required: false,
                type: 'number',

                snippetCodename: 'carousel_config'
            },

            /**
             * Autoplay  timer (number)
             */
            carousel_config__autoplay_timer: {
                codename: 'carousel_config__autoplay_timer',
                id: '9cf78efd-0ef0-4ca7-bfda-e07e9b3301ee',
                externalId: undefined,
                name: 'Autoplay: timer',
                required: false,
                type: 'number',

                snippetCodename: 'carousel_config'
            },

            /**
             * Background Color (modular_content)
             */
            background_color: {
                codename: 'background_color',
                id: 'd417ce5f-b9d4-40a7-acb3-46bae0deb4a0',
                externalId: undefined,
                name: 'Background Color',
                required: false,
                type: 'modular_content'
            },

            /**
             * Desktop  Tiles to show (number)
             */
            carousel_config__slides_to_show_desktop: {
                codename: 'carousel_config__slides_to_show_desktop',
                id: '004a406f-626a-46f6-bafe-a176ea0b95e2',
                externalId: undefined,
                name: 'Desktop: Tiles to show',
                required: true,
                type: 'number',

                snippetCodename: 'carousel_config'
            },

            /**
             * Desktop  Tiles to slide (number)
             */
            carousel_config__slides_to_scroll_desktop: {
                codename: 'carousel_config__slides_to_scroll_desktop',
                id: '4324334a-0b95-4798-813b-7059a07a44f9',
                externalId: undefined,
                name: 'Desktop: Tiles to slide',
                required: true,
                type: 'number',

                snippetCodename: 'carousel_config'
            },

            /**
             * Elements (modular_content)
             */
            elements: {
                codename: 'elements',
                id: 'c10e25a4-877e-4e79-861a-e2570b615531',
                externalId: undefined,
                name: 'Elements',
                required: true,
                type: 'modular_content'
            },

            /**
             * Enable Arrows (multiple_choice)
             */
            carousel_config__enable_arrows: {
                codename: 'carousel_config__enable_arrows',
                id: '58173a02-7497-4dcf-ae3a-b4fff1eb5055',
                externalId: undefined,
                name: 'Enable Arrows',
                required: false,
                type: 'multiple_choice',
                options: {
                    true: {
                        name: 'Yes',
                        id: 'b912173c-5327-46b2-af87-c63d75375110',
                        codename: 'true',
                        externalId: undefined
                    },
                    false: {
                        name: 'No',
                        id: '998c0c4f-acbe-492c-8f18-bbb5fa768445',
                        codename: 'false',
                        externalId: undefined
                    }
                },
                snippetCodename: 'carousel_config'
            },

            /**
             * Enable Autoplay (multiple_choice)
             *
             * Default value is "No"
             */
            carousel_config__autoplay: {
                codename: 'carousel_config__autoplay',
                id: 'e3eb6381-d988-4410-8f41-cd57511caa1b',
                externalId: undefined,
                name: 'Enable Autoplay',
                required: false,
                type: 'multiple_choice',
                options: {
                    true: {
                        name: 'Yes',
                        id: '58133a00-62fd-4aa9-aab5-09a65dfbf428',
                        codename: 'true',
                        externalId: undefined
                    },
                    false: {
                        name: 'No',
                        id: '9961be30-f973-4341-8a22-e5a72cb754b0',
                        codename: 'false',
                        externalId: undefined
                    }
                },
                snippetCodename: 'carousel_config'
            },

            /**
             * Enable Loop (multiple_choice)
             *
             * Default value is "No". If set to "Yes", the carousel will not stop when it reaches the last tile. It will be an infinite loop.
             */
            carousel_config__infinite_loop: {
                codename: 'carousel_config__infinite_loop',
                id: '610004e0-bb2d-4b05-b927-3571990e3fe7',
                externalId: undefined,
                name: 'Enable Loop',
                required: false,
                type: 'multiple_choice',
                options: {
                    true: {
                        name: 'Yes',
                        id: 'ea72ed3b-968e-4a06-b0d5-b313006cf1fa',
                        codename: 'true',
                        externalId: undefined
                    },
                    false: {
                        name: 'No',
                        id: 'e0612dac-49dc-45c8-afed-776fc6573e3e',
                        codename: 'false',
                        externalId: undefined
                    }
                },
                snippetCodename: 'carousel_config'
            },

            /**
             * List Display (multiple_choice)
             */
            list_display: {
                codename: 'list_display',
                id: 'a756d141-f48a-4a98-bbda-4acd64a56dab',
                externalId: undefined,
                name: 'List Display',
                required: true,
                type: 'multiple_choice',
                options: {
                    alert_bar_list: {
                        name: 'Alert Bar List',
                        id: '592c1e98-33df-4262-9208-51b4f7d65879',
                        codename: 'alert_bar_list',
                        externalId: undefined
                    },
                    callout_panel_list: {
                        name: 'Callout Panel List',
                        id: 'afb6a418-90eb-42c6-8f81-3284e0725c19',
                        codename: 'callout_panel_list',
                        externalId: undefined
                    }
                }
            },

            /**
             * Mobile  Tiles to show (number)
             *
             * Recommended setting as per design: 1
             */
            carousel_config__slides_to_show_mobile: {
                codename: 'carousel_config__slides_to_show_mobile',
                id: 'eedc486d-172e-4e3e-96e5-8b16f7516f49',
                externalId: undefined,
                name: 'Mobile: Tiles to show',
                required: true,
                type: 'number',

                snippetCodename: 'carousel_config'
            },

            /**
             * Mobile  Tiles to slide (number)
             */
            carousel_config__slide_to_scroll_mobile: {
                codename: 'carousel_config__slide_to_scroll_mobile',
                id: 'd471f851-b0fa-4f7f-88a3-111bac5b9e13',
                externalId: undefined,
                name: 'Mobile: Tiles to slide',
                required: true,
                type: 'number',

                snippetCodename: 'carousel_config'
            },

            /**
             * Slider Width (multiple_choice)
             *
             * If "Full width" selected: the carousel will take the parent's container width.If "None" selected: the carousel will be inside it's own container but the tiles will "break" out on the right side.
             */
            carousel_config__slider_width: {
                codename: 'carousel_config__slider_width',
                id: '0c664156-c411-4d27-a152-efcb45262348',
                externalId: undefined,
                name: 'Slider Width',
                required: false,
                type: 'multiple_choice',
                options: {
                    full_width: {
                        name: 'Full width',
                        id: 'e565c28d-fe6f-4c38-a97a-611e060c8b4c',
                        codename: 'full_width',
                        externalId: undefined
                    }
                },
                snippetCodename: 'carousel_config'
            },

            /**
             * Total Tiles to show (number)
             *
             * Show only the first x items from the elements field. Leave empty to show all
             */
            total_tiles_to_show: {
                codename: 'total_tiles_to_show',
                id: '8bbc6e6e-4286-4f6e-a7a9-c42781fb621a',
                externalId: undefined,
                name: 'Total Tiles to show',
                required: false,
                type: 'number'
            },

            /**
             * Type (multiple_choice)
             */
            type: {
                codename: 'type',
                id: 'ef8ae13b-2529-46f3-a70f-c426f5a9dbe1',
                externalId: undefined,
                name: 'Type',
                required: true,
                type: 'multiple_choice',
                options: {
                    slider: {
                        name: 'Slider',
                        id: '588c3de3-72a9-4e23-b982-a8ea3035f3d7',
                        codename: 'slider',
                        externalId: undefined
                    },
                    grid: {
                        name: 'Grid',
                        id: 'cfb90e44-c83b-4ec7-9a8f-e09fbc678efb',
                        codename: 'grid',
                        externalId: undefined
                    },
                    plain_list: {
                        name: 'Plain List',
                        id: '976e6965-bddf-479c-92af-db987dbd4b48',
                        codename: 'plain_list',
                        externalId: undefined
                    }
                }
            }
        }
    },

    /**
     * Cookies Popup
     */
    cookies_popup: {
        codename: 'cookies_popup',
        id: '23a9c563-b267-404d-945d-06f371f82fbe',
        externalId: undefined,
        name: 'Cookies Popup',
        elements: {
            /**
             * Button Label (text)
             */
            button_label: {
                codename: 'button_label',
                id: '9a7125f9-8aa6-4574-8a86-429cc9cca520',
                externalId: undefined,
                name: 'Button Label',
                required: false,
                type: 'text'
            },

            /**
             * Cookies Page Link (modular_content)
             */
            cookies_page_link: {
                codename: 'cookies_page_link',
                id: '7daad8fb-19b3-4a06-b680-037d8f739acb',
                externalId: undefined,
                name: 'Cookies Page Link',
                required: false,
                type: 'modular_content'
            },

            /**
             * Description (text)
             */
            description: {
                codename: 'description',
                id: 'f19d84fd-3398-43f0-ae7e-aed4cb5315f5',
                externalId: undefined,
                name: 'Description',
                required: false,
                type: 'text'
            },

            /**
             * Details Subscription (text)
             */
            details_subscription: {
                codename: 'details_subscription',
                id: 'a6e1fdd0-9a84-4ffa-a487-f16199a80490',
                externalId: undefined,
                name: 'Details Subscription',
                required: false,
                type: 'text'
            },

            /**
             * Details Subtext (text)
             */
            details_subtext: {
                codename: 'details_subtext',
                id: '3307ce10-f627-4bc6-8e73-563083843641',
                externalId: undefined,
                name: 'Details Subtext',
                required: false,
                type: 'text'
            },

            /**
             * Logo Image (asset)
             */
            logo_image: {
                codename: 'logo_image',
                id: 'ebb8f120-467d-45c7-b0b2-f2f1b201993a',
                externalId: undefined,
                name: 'Logo Image',
                required: false,
                type: 'asset'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'b7b95ff3-32b0-466e-bae1-ea4571b24c69',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Cookies Settings
     */
    cookies_settings: {
        codename: 'cookies_settings',
        id: '9def9c46-0995-40bb-acfc-1fb6afaa30c9',
        externalId: undefined,
        name: 'Cookies Settings',
        elements: {
            /**
             * Accept All Button Label (text)
             */
            accept_all_button_label: {
                codename: 'accept_all_button_label',
                id: '4aa5e941-6474-4821-91f9-8613cc99b1b1',
                externalId: undefined,
                name: 'Accept All Button Label',
                required: false,
                type: 'text'
            },

            /**
             * Consent Cookies Expiry Days (number)
             */
            consent_cookies_expiry_days: {
                codename: 'consent_cookies_expiry_days',
                id: '879913ef-677a-4ce4-96df-e0de4ef78698',
                externalId: undefined,
                name: 'Consent Cookies Expiry Days',
                required: false,
                type: 'number'
            },

            /**
             * Cookies (multiple_choice)
             */
            functional_cookies_cookies: {
                codename: 'functional_cookies_cookies',
                id: '04ea3f0b-86e3-4d37-a066-d50d5393e352',
                externalId: undefined,
                name: 'Cookies',
                required: false,
                type: 'multiple_choice',
                options: {}
            },

            /**
             * Cookies Names (modular_content)
             */
            necessary_cookies_names: {
                codename: 'necessary_cookies_names',
                id: 'e9a692e1-0e7b-4aa9-9f3e-90f8a4822c63',
                externalId: undefined,
                name: 'Cookies Names',
                required: false,
                type: 'modular_content'
            },

            /**
             * Cookies Names (modular_content)
             */
            performance_cookies_names: {
                codename: 'performance_cookies_names',
                id: 'e0216f38-78f7-4b75-b3a6-07e298be3560',
                externalId: undefined,
                name: 'Cookies Names',
                required: false,
                type: 'modular_content'
            },

            /**
             * Cookies Names (modular_content)
             */
            functional_cookies_names: {
                codename: 'functional_cookies_names',
                id: 'c88f3b78-bd05-4250-8881-67d5c11305d8',
                externalId: undefined,
                name: 'Cookies Names',
                required: false,
                type: 'modular_content'
            },

            /**
             * Description (text)
             */
            description: {
                codename: 'description',
                id: '666f283b-6c5a-4f0e-91ab-73f83539f038',
                externalId: undefined,
                name: 'Description',
                required: true,
                type: 'text'
            },

            /**
             * Description (text)
             */
            necessary_cookies_description: {
                codename: 'necessary_cookies_description',
                id: '46c39575-da4a-42e2-95a7-3778b4d9f207',
                externalId: undefined,
                name: 'Description',
                required: true,
                type: 'text'
            },

            /**
             * Description (text)
             */
            performance_cookies_description: {
                codename: 'performance_cookies_description',
                id: '1439f446-b862-45dd-bd06-1117b8e5fe6d',
                externalId: undefined,
                name: 'Description',
                required: false,
                type: 'text'
            },

            /**
             * Description (text)
             */
            functional_cookies_description: {
                codename: 'functional_cookies_description',
                id: 'dd13c9b6-6cc5-45f1-a9eb-8c5cb304d877',
                externalId: undefined,
                name: 'Description',
                required: false,
                type: 'text'
            },

            /**
             * Details Description (text)
             */
            details_description: {
                codename: 'details_description',
                id: '1f4320a9-34d1-43c7-ac8c-ca379b25ef96',
                externalId: undefined,
                name: 'Details Description',
                required: true,
                type: 'text'
            },

            /**
             * Details Link (modular_content)
             */
            details_link: {
                codename: 'details_link',
                id: '9723bb12-6a8d-42c4-b5ba-e1e2e48b31e2',
                externalId: undefined,
                name: 'Details Link',
                required: false,
                type: 'modular_content'
            },

            /**
             * Details Updated Date (date_time)
             */
            details_updated_date: {
                codename: 'details_updated_date',
                id: '8093e748-b05e-4f1b-b5d1-b6aa89d852bb',
                externalId: undefined,
                name: 'Details Updated Date',
                required: false,
                type: 'date_time'
            },

            /**
             * Google Tag Manager Id (text)
             */
            performance_cookies_google_tag_manager_id: {
                codename: 'performance_cookies_google_tag_manager_id',
                id: '59ef7d0a-0645-486e-9d3d-1eb554cb88f7',
                externalId: undefined,
                name: 'Google Tag Manager Id',
                required: false,
                type: 'text'
            },

            /**
             * Label (text)
             */
            necessary_cookies_label: {
                codename: 'necessary_cookies_label',
                id: 'ac6df6e0-d9a2-44a3-a159-04d07b71276b',
                externalId: undefined,
                name: 'Label',
                required: true,
                type: 'text'
            },

            /**
             * Label (text)
             */
            performance_cookies_label: {
                codename: 'performance_cookies_label',
                id: '8cb8b896-e50d-44a3-955b-0565d82f2b5f',
                externalId: undefined,
                name: 'Label',
                required: false,
                type: 'text'
            },

            /**
             * Label (text)
             */
            functional_cookies_label: {
                codename: 'functional_cookies_label',
                id: '5ebee7b7-c167-4940-aeb7-3c4f24ce5054',
                externalId: undefined,
                name: 'Label',
                required: false,
                type: 'text'
            },

            /**
             * Lawful Basis (multiple_choice)
             */
            performance_cookies_lawful_basis: {
                codename: 'performance_cookies_lawful_basis',
                id: 'e53a3f53-ca52-4fd0-8cd8-7f5e0837f406',
                externalId: undefined,
                name: 'Lawful Basis',
                required: true,
                type: 'multiple_choice',
                options: {
                    consent: {
                        name: 'consent',
                        id: '9bc9dca6-b73f-43b7-a5c6-27d81738426f',
                        codename: 'consent',
                        externalId: undefined
                    },
                    legitimate_interest: {
                        name: 'legitimate interest',
                        id: '22eb3ebc-c0b3-413c-b094-36e3eb1975c7',
                        codename: 'legitimate_interest',
                        externalId: undefined
                    }
                }
            },

            /**
             * Lawful Basis (multiple_choice)
             */
            functional_cookies_lawful_basis: {
                codename: 'functional_cookies_lawful_basis',
                id: '94a3c8ef-992a-442e-8466-06ecfa8eb8e3',
                externalId: undefined,
                name: 'Lawful Basis',
                required: false,
                type: 'multiple_choice',
                options: {
                    consent: {
                        name: 'consent',
                        id: '01310680-775f-476e-b16a-4d0dbd437eab',
                        codename: 'consent',
                        externalId: undefined
                    },
                    legitimate_interest: {
                        name: 'legitimate interest',
                        id: '65d11b45-6b9b-4737-a81d-d6e1738e90be',
                        codename: 'legitimate_interest',
                        externalId: undefined
                    }
                }
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'b8264134-266e-48f9-a258-36b77f12f238',
                externalId: undefined,
                name: 'Title',
                required: true,
                type: 'text'
            },

            /**
             * Title (text)
             */
            necessary_cookies_title: {
                codename: 'necessary_cookies_title',
                id: '5625526e-1768-4d80-9980-f1417df09fe0',
                externalId: undefined,
                name: 'Title',
                required: true,
                type: 'text'
            },

            /**
             * Title (text)
             */
            performance_cookies_title: {
                codename: 'performance_cookies_title',
                id: '8b31e320-2461-4dde-b382-2cca906d4483',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            },

            /**
             * Title (text)
             */
            functional_cookies_title: {
                codename: 'functional_cookies_title',
                id: '6ad59317-e24d-487c-b1b9-1bf5c9e53169',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            },

            /**
             * Toggle Off Label (text)
             */
            toggle_off_label: {
                codename: 'toggle_off_label',
                id: 'dd0cb0cc-af25-40c2-b9bc-77c84b23b071',
                externalId: undefined,
                name: 'Toggle Off Label',
                required: false,
                type: 'text'
            },

            /**
             * Toggle On Label (text)
             */
            toggle_on_label: {
                codename: 'toggle_on_label',
                id: '8827b942-38ec-4efd-ac2a-f23d42a75a00',
                externalId: undefined,
                name: 'Toggle On Label',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Country
     */
    player_portals_country: {
        codename: 'player_portals_country',
        id: '56312ef0-331e-4062-a0e9-59aabfe069ce',
        externalId: undefined,
        name: 'Country',
        elements: {
            /**
             * Country ID (text)
             */
            country_id: {
                codename: 'country_id',
                id: '2a6a6ac4-b779-4d34-82d0-ba482f984804',
                externalId: undefined,
                name: 'Country ID',
                required: false,
                type: 'text'
            },

            /**
             * Id (text)
             */
            id: {
                codename: 'id',
                id: '2ce6e7af-3719-400b-8d56-de2940c5ca28',
                externalId: undefined,
                name: 'Id',
                required: false,
                type: 'text'
            },

            /**
             * ISO Code 2 (text)
             */
            iso_code_2: {
                codename: 'iso_code_2',
                id: '18b58dc6-3fc8-42f9-955e-30a366b31a0f',
                externalId: undefined,
                name: 'ISO Code 2',
                required: false,
                type: 'text'
            },

            /**
             * ISO Code 3 (text)
             */
            iso_code_3: {
                codename: 'iso_code_3',
                id: 'a6cc592d-fc11-4fd6-bf60-b6d1ea8ae027',
                externalId: undefined,
                name: 'ISO Code 3',
                required: false,
                type: 'text'
            },

            /**
             * Name (text)
             */
            name: {
                codename: 'name',
                id: '0eb19378-ce3b-476a-a512-25a392fc77c9',
                externalId: undefined,
                name: 'Name',
                required: false,
                type: 'text'
            },

            /**
             * Numeric Iso (text)
             */
            numeric_iso: {
                codename: 'numeric_iso',
                id: '01626e2b-dd9e-42de-ac6e-76326ff2423d',
                externalId: undefined,
                name: 'Numeric Iso',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * CTA
     */
    cta: {
        codename: 'cta',
        id: '5764fa45-4774-4c45-8f67-52e77580444e',
        externalId: undefined,
        name: 'CTA',
        elements: {
            /**
             * Background Color (modular_content)
             */
            background_color: {
                codename: 'background_color',
                id: '583176dc-0d95-4f5f-841e-973d1bab6c3b',
                externalId: undefined,
                name: 'Background Color',
                required: false,
                type: 'modular_content'
            },

            /**
             * Border Color (modular_content)
             */
            border_color: {
                codename: 'border_color',
                id: '38262ce1-1733-4724-8f9a-f4c958b8b29b',
                externalId: undefined,
                name: 'Border Color',
                required: false,
                type: 'modular_content'
            },

            /**
             * Label (text)
             */
            label: {
                codename: 'label',
                id: '7a044ffc-d97d-4ade-aa81-03d0ac18e13c',
                externalId: undefined,
                name: 'Label',
                required: false,
                type: 'text'
            },

            /**
             * Opacity (number)
             */
            opacity: {
                codename: 'opacity',
                id: '9f52e23e-487a-4fad-b500-c0204af7055a',
                externalId: undefined,
                name: 'Opacity',
                required: false,
                type: 'number'
            },

            /**
             * Resource (modular_content)
             */
            resource: {
                codename: 'resource',
                id: 'caed929c-8454-48f0-8594-e657e8b49554',
                externalId: undefined,
                name: 'Resource',
                required: false,
                type: 'modular_content'
            },

            /**
             * Text Color (modular_content)
             */
            text_color: {
                codename: 'text_color',
                id: '6375b40b-1b91-41ab-9935-da2f78e9e787',
                externalId: undefined,
                name: 'Text Color',
                required: false,
                type: 'modular_content'
            },

            /**
             * Theme (multiple_choice)
             */
            theme: {
                codename: 'theme',
                id: '49d53404-512d-4b96-88f2-1b4ff29c3881',
                externalId: undefined,
                name: 'Theme',
                required: false,
                type: 'multiple_choice',
                options: {}
            },

            /**
             * Type (multiple_choice)
             */
            type: {
                codename: 'type',
                id: '9d1686e1-c026-4138-b6f0-fea7fbde6898',
                externalId: undefined,
                name: 'Type',
                required: true,
                type: 'multiple_choice',
                options: {
                    button: {
                        name: 'Button',
                        id: '42423b1b-7c87-41cc-b239-1d07b984829e',
                        codename: 'button',
                        externalId: undefined
                    },
                    submit: {
                        name: 'Submit',
                        id: '840b677c-f68c-4491-9072-652b0f5e711f',
                        codename: 'submit',
                        externalId: undefined
                    },
                    reset: {
                        name: 'Reset',
                        id: '59d04494-822a-4b08-9734-f7d4a2e698af',
                        codename: 'reset',
                        externalId: undefined
                    }
                }
            }
        }
    },

    /**
     * Data Grid Table
     */
    data_grid_table: {
        codename: 'data_grid_table',
        id: 'fdb85063-85b1-4793-a78e-ba78ef8e23d1',
        externalId: undefined,
        name: 'Data Grid Table',
        elements: {
            /**
             * Accredited Members Table (modular_content)
             */
            accredited_members_table: {
                codename: 'accredited_members_table',
                id: '772f7f09-0245-469b-9820-910b1f85b5a5',
                externalId: undefined,
                name: 'Accredited Members Table',
                required: false,
                type: 'modular_content'
            },

            /**
             * Callback URL (modular_content)
             */
            callback_url: {
                codename: 'callback_url',
                id: 'd1728a5a-6871-46dd-9b83-b2a0c83e0cac',
                externalId: undefined,
                name: 'Callback URL',
                required: true,
                type: 'modular_content'
            },

            /**
             * Columns (modular_content)
             */
            columns: {
                codename: 'columns',
                id: '8b4da6db-b80e-431c-b4a6-f4861be3eeae',
                externalId: undefined,
                name: 'Columns',
                required: false,
                type: 'modular_content'
            },

            /**
             * Default Rows Per Page (multiple_choice)
             *
             * Default value: 10
             */
            default_rows_per_page: {
                codename: 'default_rows_per_page',
                id: '109f591a-ff40-45e7-8973-e6c4cd9357d7',
                externalId: undefined,
                name: 'Default Rows Per Page',
                required: false,
                type: 'multiple_choice',
                options: {
                    n5: {
                        name: '5',
                        id: 'e58d05b6-ca09-472d-b936-de8ac8d7a550',
                        codename: 'n5',
                        externalId: undefined
                    },
                    n10: {
                        name: '10',
                        id: '587aff59-461a-4694-ba68-6fa60d035767',
                        codename: 'n10',
                        externalId: undefined
                    },
                    n15: {
                        name: '15',
                        id: 'd0b09ab5-5b97-48c7-900a-7eae81e5fe18',
                        codename: 'n15',
                        externalId: undefined
                    }
                }
            },

            /**
             * Default Sort Column (modular_content)
             */
            default_table_sorting__default_sort_column: {
                codename: 'default_table_sorting__default_sort_column',
                id: '2b3022c2-be38-4515-b22d-1605539b563f',
                externalId: undefined,
                name: 'Default Sort Column',
                required: false,
                type: 'modular_content',

                snippetCodename: 'default_table_sorting'
            },

            /**
             * Default Sort Direction (multiple_choice)
             */
            default_table_sorting__default_sort_direction: {
                codename: 'default_table_sorting__default_sort_direction',
                id: '6ff0ed4c-7ba1-4690-a288-9fcb13d5ac7f',
                externalId: undefined,
                name: 'Default Sort Direction',
                required: false,
                type: 'multiple_choice',
                options: {
                    asc: {
                        name: 'asc',
                        id: '558b7085-0de5-480a-8bac-988b88353605',
                        codename: 'asc',
                        externalId: undefined
                    },
                    desc: {
                        name: 'desc',
                        id: '5b917353-b660-4ec6-9522-eceb7f22d73b',
                        codename: 'desc',
                        externalId: undefined
                    }
                },
                snippetCodename: 'default_table_sorting'
            },

            /**
             * ID Card (modular_content)
             */
            id_card: {
                codename: 'id_card',
                id: '30388256-81cc-4184-b650-790912aeeb0d',
                externalId: undefined,
                name: 'ID Card',
                required: false,
                type: 'modular_content'
            },

            /**
             * Managers Table Label (text)
             */
            managers_table_label: {
                codename: 'managers_table_label',
                id: '30930ce0-5580-4602-955d-1c04252fa37e',
                externalId: undefined,
                name: 'Managers Table Label',
                required: false,
                type: 'text'
            },

            /**
             * Players Table Label (text)
             */
            players_table_label: {
                codename: 'players_table_label',
                id: 'bfe8ba4d-5586-4e3e-a5e6-ad058d0bab8e',
                externalId: undefined,
                name: 'Players Table Label',
                required: false,
                type: 'text'
            },

            /**
             * Roles (taxonomy)
             */
            roles: {
                codename: 'roles',
                id: 'c0fb2e7b-4d3b-46d2-94e8-4aec2292b5f2',
                externalId: undefined,
                name: 'Roles',
                required: false,
                type: 'taxonomy'
            }
        }
    },

    /**
     * Dictionary Item
     */
    dictionary_item: {
        codename: 'dictionary_item',
        id: '74aa6199-6373-4b0f-930e-a240d598f0e3',
        externalId: undefined,
        name: 'Dictionary Item',
        elements: {
            /**
             * Key (text)
             */
            key: {
                codename: 'key',
                id: 'b0caffec-34cc-4f53-9991-4e59daf50670',
                externalId: undefined,
                name: 'Key',
                required: true,
                type: 'text'
            },

            /**
             * Value (text)
             */
            value: {
                codename: 'value',
                id: '97decc19-3b2a-4c42-993c-71f932ea363c',
                externalId: undefined,
                name: 'Value',
                required: true,
                type: 'text'
            }
        }
    },

    /**
     * Dictionary with Linked Item
     */
    dictionary_with_linked_item: {
        codename: 'dictionary_with_linked_item',
        id: '88c3d243-cf29-497d-ba12-99a7046d762a',
        externalId: undefined,
        name: 'Dictionary with Linked Item',
        elements: {
            /**
             * Item (modular_content)
             */
            item: {
                codename: 'item',
                id: 'cb172458-5248-4ad2-b0a8-29809d21225f',
                externalId: undefined,
                name: 'Item',
                required: false,
                type: 'modular_content'
            },

            /**
             * Key (text)
             */
            key: {
                codename: 'key',
                id: '5273476e-be52-4f2f-914b-f81980630bf8',
                externalId: undefined,
                name: 'Key',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * File Embed
     */
    file_embed: {
        codename: 'file_embed',
        id: 'bb3026f1-5aba-4e42-9ba8-d24903d42b32',
        externalId: undefined,
        name: 'File Embed',
        elements: {
            /**
             * Resource (asset)
             *
             * Insert a pdf file or an image
             */
            resource: {
                codename: 'resource',
                id: 'b26fc21d-3364-4706-aa5f-4f67b0f923c1',
                externalId: undefined,
                name: 'Resource',
                required: true,
                type: 'asset'
            }
        }
    },

    /**
     * Footer
     */
    player_portals_footer: {
        codename: 'player_portals_footer',
        id: '59c8ca76-7c00-404b-a5ea-b9f5a22147e4',
        externalId: undefined,
        name: 'Footer',
        elements: {
            /**
             * Copyright Notice (text)
             */
            copyright_notice: {
                codename: 'copyright_notice',
                id: 'f31c6bbe-570d-4a9f-a6c6-b0eac554353e',
                externalId: undefined,
                name: 'Copyright Notice',
                required: false,
                type: 'text'
            },

            /**
             * Desktop Background Image (asset)
             */
            desktop_background_image: {
                codename: 'desktop_background_image',
                id: 'a834e50b-47df-4d10-a124-ffdea4dcefcd',
                externalId: undefined,
                name: 'Desktop Background Image',
                required: false,
                type: 'asset'
            },

            /**
             * Links (modular_content)
             *
             * A maximum of 8 link items is recommended for optimal layout
             */
            links: {
                codename: 'links',
                id: '860337aa-0280-4fb3-84e9-ac4c543180b6',
                externalId: undefined,
                name: 'Links',
                required: false,
                type: 'modular_content'
            },

            /**
             * Mobile Background Image (asset)
             */
            mobile_background_image: {
                codename: 'mobile_background_image',
                id: 'bc370ffb-bc7c-454a-b838-5833cc6f6a2b',
                externalId: undefined,
                name: 'Mobile Background Image',
                required: false,
                type: 'asset'
            },

            /**
             * Organization Logos (modular_content)
             */
            organization_logos: {
                codename: 'organization_logos',
                id: 'c5491821-ae4a-4f7d-b23b-871b6192ca2a',
                externalId: undefined,
                name: 'Organization Logos',
                required: true,
                type: 'modular_content'
            }
        }
    },

    /**
     * Form
     */
    player_portals_form: {
        codename: 'player_portals_form',
        id: '9ac68882-650a-455c-b44d-5c910e469b78',
        externalId: undefined,
        name: 'Form',
        elements: {
            /**
             * Custom Classname (text)
             */
            custom_classname: {
                codename: 'custom_classname',
                id: 'e7f9e105-c76e-48e5-84a6-46662110ea97',
                externalId: undefined,
                name: 'Custom Classname',
                required: false,
                type: 'text'
            },

            /**
             * Default Values Callback URL (modular_content)
             */
            default_values_callback_url: {
                codename: 'default_values_callback_url',
                id: '5bd46d01-c15c-40ae-928f-8e96597948e9',
                externalId: undefined,
                name: 'Default Values Callback URL',
                required: false,
                type: 'modular_content'
            },

            /**
             * Roles (taxonomy)
             *
             * This field should be used only for Pre-Registration forms
             */
            default_values_entity: {
                codename: 'default_values_entity',
                id: '9198ebda-2c3f-4bd7-9862-56f598ba7c2b',
                externalId: undefined,
                name: 'Default Values Entity',
                required: false,
                type: 'taxonomy'
            },

            /**
             * Default Values JSON (text)
             */
            default_values_json: {
                codename: 'default_values_json',
                id: '26bc0071-9727-43b1-a00b-443b058348c7',
                externalId: undefined,
                name: 'Default Values JSON',
                required: false,
                type: 'text'
            },

            /**
             * Errors Messages (modular_content)
             */
            errors_messages: {
                codename: 'errors_messages',
                id: 'c2c2414d-af54-41e7-b4fe-4c4e8abdb8f3',
                externalId: undefined,
                name: 'Errors Messages',
                required: false,
                type: 'modular_content'
            },

            /**
             * Form Content (modular_content)
             */
            form_content: {
                codename: 'form_content',
                id: 'ddd73526-a383-46fe-87d7-eba1f1d2ba2a',
                externalId: undefined,
                name: 'Form Content',
                required: true,
                type: 'modular_content'
            },

            /**
             * Form Footer (modular_content)
             */
            form_footer: {
                codename: 'form_footer',
                id: '9ba005d1-047a-47f0-a878-5fddf73b07b6',
                externalId: undefined,
                name: 'Form Footer',
                required: false,
                type: 'modular_content'
            },

            /**
             * Form Header (modular_content)
             */
            form_header: {
                codename: 'form_header',
                id: '37f2319f-b199-4a68-b0d2-58ed92f4a59b',
                externalId: undefined,
                name: 'Form Header',
                required: false,
                type: 'modular_content'
            },

            /**
             * Form Type (multiple_choice)
             */
            form_type: {
                codename: 'form_type',
                id: 'ecb1a9cc-5dc5-480f-827f-c746b19e5647',
                externalId: undefined,
                name: 'Form Type',
                required: false,
                type: 'multiple_choice',
                options: {
                    classic: {
                        name: 'Classic',
                        id: '030f275c-a3e3-4fa5-a412-c7b8d86f853a',
                        codename: 'classic',
                        externalId: undefined
                    },
                    with_preview_and_modal: {
                        name: 'With Preview and Modal',
                        id: 'd450cf09-d8cd-43ec-bdc1-8d746f86eb49',
                        codename: 'with_preview_and_modal',
                        externalId: undefined
                    }
                }
            },

            /**
             * Next Steps (modular_content)
             */
            next_steps: {
                codename: 'next_steps',
                id: '60fe18c1-1245-4ecc-af63-816229cba717',
                externalId: undefined,
                name: 'Next Steps',
                required: false,
                type: 'modular_content'
            },

            /**
             * Success Messages (modular_content)
             */
            success_messages: {
                codename: 'success_messages',
                id: '68e8b808-a530-4d10-b8f8-f41d088cbb33',
                externalId: undefined,
                name: 'Success Messages',
                required: false,
                type: 'modular_content'
            }
        }
    },

    /**
     * Form CTA
     */
    form_cta: {
        codename: 'form_cta',
        id: '24352400-7ba5-40cf-af38-00187753a43d',
        externalId: undefined,
        name: 'Form CTA',
        elements: {
            /**
             * Action Type (multiple_choice)
             */
            form_cta_action_types__action_type: {
                codename: 'form_cta_action_types__action_type',
                id: 'b5d5db59-656c-42e5-b2eb-ff4420c057e2',
                externalId: undefined,
                name: 'Action Type',
                required: true,
                type: 'multiple_choice',
                options: {
                    redirect_to: {
                        name: 'Redirect To',
                        id: '1bda58e2-ed0e-4dd0-a074-e573da60b10c',
                        codename: 'redirect_to',
                        externalId: undefined
                    },
                    redirect_to_preserve_query: {
                        name: 'Redirect To   Preserve Query',
                        id: '11b074b2-4cc1-41a3-8d81-01cf48e1c48d',
                        codename: 'redirect_to_preserve_query',
                        externalId: undefined
                    },
                    sign_in: {
                        name: 'Sign In',
                        id: '580353be-a4b8-4976-af2b-6584aff64a62',
                        codename: 'sign_in',
                        externalId: undefined
                    },
                    next_step: {
                        name: 'Next Step',
                        id: 'c24283e1-f071-4d94-9e93-9edacfbcddec',
                        codename: 'next_step',
                        externalId: undefined
                    },
                    skip_step: {
                        name: 'Skip Step',
                        id: '0c51fb1d-76b0-491e-bf49-c55b58bdc19b',
                        codename: 'skip_step',
                        externalId: undefined
                    },
                    previous_step: {
                        name: 'Previous Step',
                        id: '77ee3a7f-d35d-4b67-ac75-4b34c24c1ebb',
                        codename: 'previous_step',
                        externalId: undefined
                    },
                    update: {
                        name: 'Update',
                        id: 'bfbf0976-41cb-4352-85ee-1a3d1b700f37',
                        codename: 'update',
                        externalId: undefined
                    },
                    update_next_step: {
                        name: 'Update   Next Step',
                        id: 'f0979b5b-8612-44f2-b177-9092a45ac5ef',
                        codename: 'update_next_step',
                        externalId: undefined
                    },
                    update_exit: {
                        name: 'Update   Exit',
                        id: 'e7019024-8e8d-427f-8206-00165e9ce6c6',
                        codename: 'update_exit',
                        externalId: undefined
                    },
                    forgot_password: {
                        name: 'Forgot Password',
                        id: 'fb1b8013-45f0-482f-829f-e4ee90bc3dfa',
                        codename: 'forgot_password',
                        externalId: undefined
                    },
                    reset_password: {
                        name: 'Reset Password',
                        id: '1f2efadd-e76b-4f46-a0b9-1f319ac72277',
                        codename: 'reset_password',
                        externalId: undefined
                    },
                    new_password_required: {
                        name: 'New Password Required',
                        id: '21775c07-1735-4c2e-b00f-43994342645f',
                        codename: 'new_password_required',
                        externalId: undefined
                    },
                    change_password: {
                        name: 'Change Password',
                        id: 'ec1e78bb-63eb-441e-b406-1b6b69121ea0',
                        codename: 'change_password',
                        externalId: undefined
                    },
                    skip_with_no_validation: {
                        name: 'Skip With No Validation',
                        id: 'b813bb3d-4ec1-48c4-a20f-a973452f0ba7',
                        codename: 'skip_with_no_validation',
                        externalId: undefined
                    },
                    reset_exit: {
                        name: 'Reset   Exit',
                        id: 'ee32a899-56f6-42cb-869e-07928026f386',
                        codename: 'reset_exit',
                        externalId: undefined
                    },
                    create_accreditation_contact: {
                        name: 'Create Accreditation Contact',
                        id: '2787e1df-a5ae-41b9-be89-07eaa510cfb5',
                        codename: 'create_accreditation_contact',
                        externalId: undefined
                    },
                    create_online_entry: {
                        name: 'Create Online Entry',
                        id: 'ec636dcc-bc57-4851-8e55-7bafa3aff691',
                        codename: 'create_online_entry',
                        externalId: undefined
                    },
                    create_online_entry_next: {
                        name: 'Create Online Entry   Next',
                        id: 'e992fb36-136a-482a-b2b7-93d5ba4553da',
                        codename: 'create_online_entry_next',
                        externalId: undefined
                    },
                    create_online_entry_redirect_to_preserve_query: {
                        name: 'Create Online Entry   Redirect To   Preserve Query',
                        id: '09d35158-800c-49a9-b0a2-cb74c14cc611',
                        codename: 'create_online_entry_redirect_to_preserve_query',
                        externalId: undefined
                    }
                },
                snippetCodename: 'form_cta_action_types'
            },

            /**
             * CTA (modular_content)
             */
            cta: {
                codename: 'cta',
                id: 'a0d6c7ed-38fa-46be-bf90-80d4481957e2',
                externalId: undefined,
                name: 'CTA',
                required: true,
                type: 'modular_content'
            }
        }
    },

    /**
     * Form Date Field
     */
    form_date_field: {
        codename: 'form_date_field',
        id: 'c2a2bdbf-43d8-4c05-8f30-36b9abb46814',
        externalId: undefined,
        name: 'Form Date Field',
        elements: {
            /**
             * Compute Age (multiple_choice)
             */
            compute_age: {
                codename: 'compute_age',
                id: '959b94f4-efd9-4bda-98d8-d831e5ff9eb2',
                externalId: undefined,
                name: 'Compute Age',
                required: false,
                type: 'multiple_choice',
                options: {
                    true: {
                        name: 'True',
                        id: '18d1a95d-231f-4ad2-9209-66b59922189f',
                        codename: 'true',
                        externalId: undefined
                    },
                    false: {
                        name: 'False',
                        id: '7a62edfa-b006-44e3-a26d-6d888c6e8632',
                        codename: 'false',
                        externalId: undefined
                    }
                }
            },

            /**
             * Form Field (modular_content)
             */
            form_field: {
                codename: 'form_field',
                id: 'cc838f1b-2036-4cad-bee8-428bb0cdf9b1',
                externalId: undefined,
                name: 'Form Field',
                required: false,
                type: 'modular_content'
            },

            /**
             * Minimum Year (number)
             */
            minimum_year: {
                codename: 'minimum_year',
                id: '71606c13-e51a-4660-9c3f-e5d3932466bd',
                externalId: undefined,
                name: 'Minimum Year',
                required: false,
                type: 'number'
            },

            /**
             * Year Offset (number)
             */
            year_offset: {
                codename: 'year_offset',
                id: 'dcab9fbf-f1d3-49b6-8547-f73a42d060bb',
                externalId: undefined,
                name: 'Year Offset',
                required: false,
                type: 'number'
            }
        }
    },

    /**
     * Form Field
     */
    form_field: {
        codename: 'form_field',
        id: '86b6f1ad-7210-4856-988a-05001709d93f',
        externalId: undefined,
        name: 'Form Field',
        elements: {
            /**
             * Compute Age  only for Date fields  (multiple_choice)
             *
             * Selecting Yes will add a helper field with the ID {currentFieldId}Age, automatically populated with the age calculated from the current field’s date value.
             */
            compute_age: {
                codename: 'compute_age',
                id: '9d8e62c0-8e3e-4d99-af13-89cdf1229789',
                externalId: undefined,
                name: 'Compute Age (only for Date fields)',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: '0a842000-ea69-441f-96d4-8908ef745c56',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: '090ec11a-f044-4ebd-aed5-598855aa4eb0',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            },

            /**
             * Default Option (modular_content)
             *
             * If the field is of type 'Checkboxes', the checks will default to this option
             */
            default_option: {
                codename: 'default_option',
                id: '741cb95f-b275-49df-b4d9-27dbcd851076',
                externalId: undefined,
                name: 'Default Option',
                required: false,
                type: 'modular_content'
            },

            /**
             * Dependency Criteria (multiple_choice)
             */
            dependency_criteria: {
                codename: 'dependency_criteria',
                id: '61dbeec1-e6c7-483d-a9f0-a7b13e5a09fd',
                externalId: undefined,
                name: 'Dependency Criteria',
                required: false,
                type: 'multiple_choice',
                options: {
                    equals: {
                        name: 'Equals',
                        id: '67a99447-fb45-4915-921d-b8c9841071c7',
                        codename: 'equals',
                        externalId: undefined
                    },
                    equals___ignore_case: {
                        name: 'Equals   Ignore Case',
                        id: 'c34d3f7a-33bd-40b9-bbc5-a548b02eae50',
                        codename: 'equals___ignore_case',
                        externalId: undefined
                    },
                    not_equals: {
                        name: 'Not Equals',
                        id: '3a8a6139-ac35-4336-a492-5562b5b74334',
                        codename: 'not_equals',
                        externalId: undefined
                    },
                    not_equals___ignore_case: {
                        name: 'Not Equals   Ignore Case',
                        id: '9a1aa888-afec-495e-a719-e71336199db1',
                        codename: 'not_equals___ignore_case',
                        externalId: undefined
                    },
                    includes: {
                        name: 'Includes',
                        id: '82ea863f-c383-4867-b0e1-82e5b056b326',
                        codename: 'includes',
                        externalId: undefined
                    },
                    includes___ignore_case: {
                        name: 'Includes   Ignore Case',
                        id: '02f3e28a-85bf-4feb-b47c-277c8560241f',
                        codename: 'includes___ignore_case',
                        externalId: undefined
                    },
                    not_includes: {
                        name: 'Not Includes',
                        id: '82647f00-d759-402d-aa9b-0b161885c06c',
                        codename: 'not_includes',
                        externalId: undefined
                    },
                    not_includes___ignore_case: {
                        name: 'Not Includes   Ignore Case',
                        id: '2900a48d-dea9-483c-ae5f-d80955b752e2',
                        codename: 'not_includes___ignore_case',
                        externalId: undefined
                    },
                    not_empty_compare: {
                        name: 'Not Empty Compare',
                        id: '16402984-7467-45e2-b6ff-6fbf156b51c2',
                        codename: 'not_empty_compare',
                        externalId: undefined
                    }
                }
            },

            /**
             * Depends On (modular_content)
             */
            depends_on: {
                codename: 'depends_on',
                id: '0bde2e9f-1ddd-48b0-966c-f90c3b4162b8',
                externalId: undefined,
                name: 'Depends On',
                required: false,
                type: 'modular_content'
            },

            /**
             * Display or Hide Field Based on Other Fields value (modular_content)
             *
             * Use this element to show or hide the current field based on the value of another field/s in the form.Example:If onlineEntries_isExempt is true, display this field. Otherwise, hide it.To configure this:Create a item of content type: Dictionary Item With Linked Item.Set the fieldId in the Key element.In the Value element create an item of content type: Relation Item.In the relation item set the value and choose the relation (e.g., equals, less than, greater than) that determines when the field becomes visible.
             */
            display_or_hide_field_based_on_other_fields_value: {
                codename: 'display_or_hide_field_based_on_other_fields_value',
                id: 'd37a3fb4-82ca-42f8-90b7-ed9808a12dc6',
                externalId: undefined,
                name: 'Display or Hide Field Based on Other Fields value',
                required: false,
                type: 'modular_content'
            },

            /**
             * Entire Object Selection (multiple_choice)
             */
            entire_object_selection: {
                codename: 'entire_object_selection',
                id: '56ab02aa-137e-4b8e-940d-023a9d83deb0',
                externalId: undefined,
                name: 'Entire Object Selection',
                required: false,
                type: 'multiple_choice',
                options: {
                    true: {
                        name: 'True',
                        id: 'a27af01c-ddd9-46a7-9566-7ae395e5da4a',
                        codename: 'true',
                        externalId: undefined
                    },
                    false: {
                        name: 'False',
                        id: '781348f4-3aaa-4b5b-a03c-89e3fb5de5e9',
                        codename: 'false',
                        externalId: undefined
                    }
                }
            },

            /**
             * Hidden Clearable (multiple_choice)
             *
             * This field works with Dropdown field type and allows enable/disable of the clearable action of the dropdown.
             */
            hidden_clearable: {
                codename: 'hidden_clearable',
                id: 'ef027b62-e10f-427e-ab12-d923d1ac7235',
                externalId: undefined,
                name: 'Hidden Clearable',
                required: false,
                type: 'multiple_choice',
                options: {
                    true: {
                        name: 'True',
                        id: '4cf8ddcc-a34d-4bbf-a3b3-e43b422895d2',
                        codename: 'true',
                        externalId: undefined
                    },
                    false: {
                        name: 'False',
                        id: '696cfa21-e8b2-4a35-ad18-beff36b648eb',
                        codename: 'false',
                        externalId: undefined
                    }
                }
            },

            /**
             * Hide Icon (multiple_choice)
             */
            hide_icon: {
                codename: 'hide_icon',
                id: '93ead072-0750-4d5c-9758-81fad4b85a83',
                externalId: undefined,
                name: 'Hide Icon',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: '8189edfe-053b-4fed-8331-f6dc3ad16e04',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: '6ab7d01e-0035-4350-894e-9223203ac487',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            },

            /**
             * Id (text)
             *
             * THIS VALUE IS USED AS THE UNIQUE FIELD ID IN CODE! CHANGING IT WITHOUT APPROPRIATE CODE ADJUSTMENTS WILL CAUSE AN APPLICATION CRASH
             */
            id: {
                codename: 'id',
                id: '78c61a74-1ac9-4c1e-9254-719842abd73f',
                externalId: undefined,
                name: 'Id',
                required: true,
                type: 'text'
            },

            /**
             * Is ReadOnly (multiple_choice)
             */
            is_readonly: {
                codename: 'is_readonly',
                id: '0274786d-cde0-48ef-b7c8-eb9f0a1c68e8',
                externalId: undefined,
                name: 'Is ReadOnly',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: 'da91eefe-0683-4906-941e-97052b627fd1',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: '6e4bac1d-2cf8-48b8-b65c-3c2d80638ce0',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            },

            /**
             * Is Required (multiple_choice)
             */
            is_required: {
                codename: 'is_required',
                id: '2fd72fa2-65f8-40b4-8488-0cd6d34bb72c',
                externalId: undefined,
                name: 'Is Required',
                required: true,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: '7fec34cd-9173-40b5-aa3b-d3e67c0c3bfe',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: 'bd5931f2-e045-499d-a6b8-199b660ea8eb',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            },

            /**
             * Label (text)
             */
            label: {
                codename: 'label',
                id: '3532b994-5f5a-458b-82c7-6d4f16c668fa',
                externalId: undefined,
                name: 'Label',
                required: false,
                type: 'text'
            },

            /**
             * Logical Name (text)
             */
            logical_name: {
                codename: 'logical_name',
                id: '284cddd4-9eea-4504-a52c-983c88ac712e',
                externalId: undefined,
                name: 'Logical Name',
                required: false,
                type: 'text'
            },

            /**
             * Multiple Validation (modular_content)
             *
             * If the field is of type 'Password With Confirm And Multiple Validation', you should add multiple validations here.
             */
            multiple_validation: {
                codename: 'multiple_validation',
                id: '6d22dc8c-87a6-4e9f-a036-a9bbebf3a161',
                externalId: undefined,
                name: 'Multiple Validation',
                required: false,
                type: 'modular_content'
            },

            /**
             * Multiple Validation Label (text)
             */
            multiple_validation_label: {
                codename: 'multiple_validation_label',
                id: 'b07784f2-a3ce-4ee5-82f7-1a73e425b4ff',
                externalId: undefined,
                name: 'Multiple Validation Label',
                required: false,
                type: 'text'
            },

            /**
             * Options (modular_content)
             *
             * If the field is of type 'Checkboxes', 'Dropdown' or 'Radio Buttons' you should add here the desired options to be displayed
             */
            options: {
                codename: 'options',
                id: 'b162c5ba-4d09-4aa5-9145-17b97327cf7d',
                externalId: undefined,
                name: 'Options',
                required: false,
                type: 'modular_content'
            },

            /**
             * Other Option Value (text)
             *
             * If a subfield has a value and the field type is Dropdown with Other or Numbered Checkboxes, enter the value for the “Other” option here. This value determines when the subfield becomes required.For Numbered Checkboxes, if multiple values should trigger validation of the Other field, list those values separated by *|*.
             */
            other_option_value: {
                codename: 'other_option_value',
                id: '01e92255-bd3c-46dd-a1e3-3c8e8a8a3175',
                externalId: undefined,
                name: 'Other Option Value',
                required: false,
                type: 'text'
            },

            /**
             * Placeholder (text)
             */
            placeholder: {
                codename: 'placeholder',
                id: 'a63bf29a-a375-4d24-92f6-0fa1dc1d8e9e',
                externalId: undefined,
                name: 'Placeholder',
                required: false,
                type: 'text'
            },

            /**
             * Predefined Options List (multiple_choice)
             */
            predefined_options_list: {
                codename: 'predefined_options_list',
                id: '4fde2b31-5f8e-42d5-b49f-fa2ea6b80df9',
                externalId: undefined,
                name: 'Predefined Options List',
                required: false,
                type: 'multiple_choice',
                options: {
                    day_options: {
                        name: 'Day Options',
                        id: '24c90d55-3320-444b-ae98-36a71f275900',
                        codename: 'day_options',
                        externalId: undefined
                    },
                    month_options: {
                        name: 'Month Options',
                        id: '8c60cf31-434f-49e1-b4bf-497e28b63fc4',
                        codename: 'month_options',
                        externalId: undefined
                    },
                    year_options: {
                        name: 'Year Options',
                        id: 'de07a0c7-ede2-4033-92ee-b9bf9f5ec18d',
                        codename: 'year_options',
                        externalId: undefined
                    },
                    handicap_category_options: {
                        name: 'Handicap Category Options',
                        id: 'a67a83e2-458c-469c-b4c9-07be4a9b03e7',
                        codename: 'handicap_category_options',
                        externalId: undefined
                    },
                    handicap_decimals_options: {
                        name: 'Handicap Decimals Options',
                        id: 'fcbfd186-d0dd-466a-90f6-90c1f6a0d169',
                        codename: 'handicap_decimals_options',
                        externalId: undefined
                    }
                }
            },

            /**
             * Subfields (modular_content)
             */
            subfields: {
                codename: 'subfields',
                id: '7350fb9c-d2ef-4199-b742-8b9faa5b1962',
                externalId: undefined,
                name: 'Subfields',
                required: false,
                type: 'modular_content'
            },

            /**
             * Type (multiple_choice)
             */
            type: {
                codename: 'type',
                id: '851ab60e-3b5a-446e-aa97-e3d78b988979',
                externalId: undefined,
                name: 'Type',
                required: true,
                type: 'multiple_choice',
                options: {
                    text: {
                        name: 'Text',
                        id: '95554769-aace-4839-9998-f60059e23d33',
                        codename: 'text',
                        externalId: undefined
                    },
                    email: {
                        name: 'Email',
                        id: 'f72cef73-447d-4189-afea-5fa70961b04a',
                        codename: 'email',
                        externalId: undefined
                    },
                    password: {
                        name: 'Password',
                        id: '88f19c48-290e-4536-b5fa-b7f80610987a',
                        codename: 'password',
                        externalId: undefined
                    },
                    password_confirmation: {
                        name: 'Password Confirmation',
                        id: '17baaa9b-2eb9-4395-a036-d30f1a5cc70b',
                        codename: 'password_confirmation',
                        externalId: undefined
                    },
                    password_with_confirm_and_multiple_validation: {
                        name: 'Password With Confirm And Multiple Validation',
                        id: '9ca7db74-0871-4e06-8175-dc2b9cae8fe9',
                        codename: 'password_with_confirm_and_multiple_validation',
                        externalId: undefined
                    },
                    phone_number: {
                        name: 'Phone Number',
                        id: 'b603449a-1c8b-412d-b6d9-eca699765909',
                        codename: 'phone_number',
                        externalId: undefined
                    },
                    date: {
                        name: 'Date',
                        id: 'af1e64e1-8730-4fee-a728-426687d8dea4',
                        codename: 'date',
                        externalId: undefined
                    },
                    number: {
                        name: 'Number',
                        id: '590304ee-a8ac-44ac-b417-574ff30bda68',
                        codename: 'number',
                        externalId: undefined
                    },
                    pp_dropdown: {
                        name: 'Dropdown',
                        id: 'c650e1be-0b85-4349-bc54-5e7bb61aca8f',
                        codename: 'pp_dropdown',
                        externalId: undefined
                    },
                    dropdowns_group: {
                        name: 'Dropdowns Group',
                        id: '9a038e0d-6d6b-4fb7-b610-05941a7fc26b',
                        codename: 'dropdowns_group',
                        externalId: undefined
                    },
                    dropdown_with_other: {
                        name: 'Dropdown With Other',
                        id: '6128d230-9522-4de4-978d-247171400fe9',
                        codename: 'dropdown_with_other',
                        externalId: undefined
                    },
                    checkboxes: {
                        name: 'Checkboxes',
                        id: 'ce61984b-2e3e-4f9e-8db8-3ad199f32bad',
                        codename: 'checkboxes',
                        externalId: undefined
                    },
                    radio_buttons: {
                        name: 'Radio Buttons',
                        id: 'a3ed1251-f10a-4d37-b8e2-ce48b7f88ad2',
                        codename: 'radio_buttons',
                        externalId: undefined
                    },
                    country: {
                        name: 'Country',
                        id: '2e94892b-6a79-4007-b0e0-839d6e367822',
                        codename: 'country',
                        externalId: undefined
                    },
                    numbered_checkboxes: {
                        name: 'Numbered Checkboxes',
                        id: '90444ad9-7ea7-4d52-8828-c9a399d3d4fd',
                        codename: 'numbered_checkboxes',
                        externalId: undefined
                    },
                    numbered_checkboxes_with_other: {
                        name: 'Numbered Checkboxes With Other',
                        id: 'd29a155f-2710-4732-86ef-80f428124d51',
                        codename: 'numbered_checkboxes_with_other',
                        externalId: undefined
                    },
                    attachment: {
                        name: 'Attachment',
                        id: 'dbb88b9a-8fb4-4d6a-9e05-f4466014e724',
                        codename: 'attachment',
                        externalId: undefined
                    },
                    hidden_field_with_value: {
                        name: 'Hidden Field With Value',
                        id: 'e06e7c3d-71ba-4b01-aab3-3c53ad644a62',
                        codename: 'hidden_field_with_value',
                        externalId: undefined
                    }
                }
            },

            /**
             * Unique Value Selection (multiple_choice)
             *
             * This field is specific to Dropdowns Group - set true on this field if you don't want to allow duplicate selected options throughout the list of options from subfields dropdowns.Example: If you set this field to true, assuming in the subfields you have dropdown1 and dropdown2, when dropdown1 value is "Venue 1", the user won't be able to select "Venue 1" in dropdown2 (the option will be disabled because it is already selected).
             */
            unique_value_selection: {
                codename: 'unique_value_selection',
                id: 'b4808429-780c-4258-a02b-ee61bfc7038b',
                externalId: undefined,
                name: 'Unique Value Selection',
                required: false,
                type: 'multiple_choice',
                options: {
                    true: {
                        name: 'True',
                        id: '710a8024-abff-48d0-8441-e5ed3eaf3a3a',
                        codename: 'true',
                        externalId: undefined
                    }
                }
            },

            /**
             * Validation Message (text)
             */
            validation_message: {
                codename: 'validation_message',
                id: '3398eaea-6bec-44fb-8fe0-a2187af7f899',
                externalId: undefined,
                name: 'Validation Message',
                required: false,
                type: 'text'
            },

            /**
             * Validation Regex (text)
             */
            validation_regex: {
                codename: 'validation_regex',
                id: '91c76810-35f5-4298-8fe0-0ecf1fe8a19e',
                externalId: undefined,
                name: 'Validation Regex',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Form Footer
     */
    form_footer: {
        codename: 'form_footer',
        id: 'eabf6341-1c67-4b27-af0c-811415681611',
        externalId: undefined,
        name: 'Form Footer',
        elements: {
            /**
             * Footer Text Color (modular_content)
             */
            footer_text_color: {
                codename: 'footer_text_color',
                id: '41eb3b69-9406-4e48-be9c-fe8eeb1113f3',
                externalId: undefined,
                name: 'Footer Text Color',
                required: false,
                type: 'modular_content'
            },

            /**
             * Forgot Password (rich_text)
             */
            forgot_password: {
                codename: 'forgot_password',
                id: '35a67708-c0fb-4f45-a195-95ec7f5f8def',
                externalId: undefined,
                name: 'Forgot Password',
                required: false,
                type: 'rich_text'
            },

            /**
             * Privacy Policy (rich_text)
             */
            privacy_policy: {
                codename: 'privacy_policy',
                id: '60409090-9944-4054-8d47-e5d55543c277',
                externalId: undefined,
                name: 'Privacy Policy',
                required: false,
                type: 'rich_text'
            },

            /**
             * Terms and Conditions (rich_text)
             */
            terms_and_conditions: {
                codename: 'terms_and_conditions',
                id: 'ac85f0fe-81ad-44c3-b389-853f3bdb86cf',
                externalId: undefined,
                name: 'Terms and Conditions',
                required: false,
                type: 'rich_text'
            }
        }
    },

    /**
     * Form Header
     */
    form_header: {
        codename: 'form_header',
        id: '489fe384-75f1-42b1-b192-a5a1e644d82f',
        externalId: undefined,
        name: 'Form Header',
        elements: {
            /**
             * Subtitle (rich_text)
             */
            subtitle: {
                codename: 'subtitle',
                id: '4c0e7fd5-ff39-49f9-85f5-0b1419a367a0',
                externalId: undefined,
                name: 'Subtitle',
                required: false,
                type: 'rich_text'
            },

            /**
             * Subtitle Color (modular_content)
             */
            subtitle_color: {
                codename: 'subtitle_color',
                id: '39ea3425-f099-4086-a6d1-db2b4ac1e08c',
                externalId: undefined,
                name: 'Subtitle Color',
                required: false,
                type: 'modular_content'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '2f6a4f75-397f-41cf-895e-1ce23aeb3338',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            },

            /**
             * Title Color (modular_content)
             */
            title_color: {
                codename: 'title_color',
                id: '8d4bac32-e735-46a5-bd83-48e9b97f602c',
                externalId: undefined,
                name: 'Title Color',
                required: false,
                type: 'modular_content'
            }
        }
    },

    /**
     * Form Step
     */
    form_step: {
        codename: 'form_step',
        id: '80a261b6-7dae-49dd-80f7-0fb31ad21345',
        externalId: undefined,
        name: 'Form Step',
        elements: {
            /**
             * CTAs (modular_content)
             */
            ctas: {
                codename: 'ctas',
                id: '1cb43374-b649-4aff-886a-dbfff0704940',
                externalId: undefined,
                name: 'CTAs',
                required: false,
                type: 'modular_content'
            },

            /**
             * Custom Header (modular_content)
             */
            custom_header: {
                codename: 'custom_header',
                id: 'ad26bdb4-3b78-4f53-9ddf-ae11c7d1b197',
                externalId: undefined,
                name: 'Custom Header',
                required: false,
                type: 'modular_content'
            },

            /**
             * Display or Hide Step Based on Field value (modular_content)
             *
             * Use this element to show or hide the current step based on the value of another field in the form.Example:If onlineEntries_isExempt is true, display this step. Otherwise, hide it.To configure this:Create a item of content type:  Dictionary Item With Linked Item.Set the fieldId in the Key element.In the Value element create an item of content type: Relation Item.In the relation item set the value and choose the relation (e.g., equals, less than, greater than) that determines when the step becomes visible.
             */
            display_or_hide_step_based_on_field_value: {
                codename: 'display_or_hide_step_based_on_field_value',
                id: '9006183b-a00c-4e83-9c83-949b6e9624f4',
                externalId: undefined,
                name: 'Display or Hide Step Based on Field value',
                required: false,
                type: 'modular_content'
            },

            /**
             * Form Fields (modular_content)
             */
            form_fields: {
                codename: 'form_fields',
                id: '1d72aa35-7e8c-4531-bd61-f34368bf2113',
                externalId: undefined,
                name: 'Form Fields',
                required: false,
                type: 'modular_content'
            },

            /**
             * Rich Text Items (modular_content)
             */
            rich_text_items: {
                codename: 'rich_text_items',
                id: '85f4b9c6-3b65-419e-bac9-78b50a040208',
                externalId: undefined,
                name: 'Rich Text Items',
                required: false,
                type: 'modular_content'
            },

            /**
             * Show Step Counter (multiple_choice)
             */
            show_step_counter: {
                codename: 'show_step_counter',
                id: 'a9da10cb-de98-4241-9f9c-79c6ac1ed87b',
                externalId: undefined,
                name: 'Show Step Counter',
                required: true,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: 'f8ecd0f8-948f-4cd9-8f2d-358a8799a0d9',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: '84c45ee3-35de-47b4-ba27-356e3231dad5',
                        codename: 'no',
                        externalId: undefined
                    }
                }
            }
        }
    },

    /**
     * Grid Page
     */
    player_portals_grid_page: {
        codename: 'player_portals_grid_page',
        id: '7777c01e-0038-4194-8a3b-f983d982dcb3',
        externalId: undefined,
        name: 'Grid Page',
        elements: {
            /**
             * Keywords (text)
             */
            seo__key_words: {
                codename: 'seo__key_words',
                id: 'd5406280-ee99-459f-bebd-2f3794765acd',
                externalId: undefined,
                name: 'Keywords',
                required: false,
                type: 'text',

                snippetCodename: 'seo'
            },

            /**
             * Meta Description (text)
             */
            seo__meta_description: {
                codename: 'seo__meta_description',
                id: '69b9ad12-66e7-4b64-92ef-389ba8cb33d8',
                externalId: undefined,
                name: 'Meta Description',
                required: false,
                type: 'text',

                snippetCodename: 'seo'
            },

            /**
             * Meta Title (text)
             */
            seo__meta_title: {
                codename: 'seo__meta_title',
                id: 'f3ef17b6-0bd4-4c1f-8e16-79d66bcb6f1f',
                externalId: undefined,
                name: 'Meta Title',
                required: true,
                type: 'text',

                snippetCodename: 'seo'
            },

            /**
             * No Follow (multiple_choice)
             */
            seo__no_follow: {
                codename: 'seo__no_follow',
                id: 'f3bbb042-2cfa-4bf2-ad97-9a4756c45275',
                externalId: undefined,
                name: 'No Follow',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: 'ed0f2d7d-e5ea-43d2-8be0-5e2b62bb8733',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: 'dba27b75-0e3e-4f06-809c-1f7ea64cdb07',
                        codename: 'no',
                        externalId: undefined
                    }
                },
                snippetCodename: 'seo'
            },

            /**
             * No Index (multiple_choice)
             */
            seo__no_index: {
                codename: 'seo__no_index',
                id: '298ecfd0-51b9-4680-bb29-bb722456d928',
                externalId: undefined,
                name: 'No Index',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: 'f70421a8-4dce-4eb4-9c8d-840a32006a86',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: 'bd5bff7b-099e-4221-a1d8-0b29f3cfc696',
                        codename: 'no',
                        externalId: undefined
                    }
                },
                snippetCodename: 'seo'
            },

            /**
             * Page Columns (modular_content)
             */
            page_columns: {
                codename: 'page_columns',
                id: '026f61fb-bacb-4c08-8841-3ff5d5503d69',
                externalId: undefined,
                name: 'Page Columns',
                required: true,
                type: 'modular_content'
            },

            /**
             * Template (modular_content)
             */
            template: {
                codename: 'template',
                id: '5b8fc9ef-4598-44c8-9826-02b40f53a2a2',
                externalId: undefined,
                name: 'Template',
                required: false,
                type: 'modular_content'
            },

            /**
             * Url Slug (url_slug)
             */
            url_slug: {
                codename: 'url_slug',
                id: 'fb4dd57d-3d70-4ffc-bd8e-ec53473c7ff3',
                externalId: undefined,
                name: 'Url Slug',
                required: false,
                type: 'url_slug'
            }
        }
    },

    /**
     * Grid Page Column
     */
    player_portals_grid_page_column: {
        codename: 'player_portals_grid_page_column',
        id: '9a432374-f8a4-45d5-aa6e-ccd77170834b',
        externalId: undefined,
        name: 'Grid Page Column',
        elements: {
            /**
             * Content (modular_content)
             */
            content: {
                codename: 'content',
                id: '3c8a22ee-9205-4c96-be45-0e5460b0c332',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'modular_content'
            }
        }
    },

    /**
     * Header
     */
    player_portals_header: {
        codename: 'player_portals_header',
        id: 'e2784c7a-a9b0-4ab7-a737-b39a42f61c44',
        externalId: undefined,
        name: 'Header',
        elements: {
            /**
             * Desktop Logo (modular_content)
             */
            desktop_logo: {
                codename: 'desktop_logo',
                id: '0fd1118b-f8e7-42f0-bb06-58caef1e4a33',
                externalId: undefined,
                name: 'Desktop Logo',
                required: false,
                type: 'modular_content'
            },

            /**
             * Hide Championship Dropdown (multiple_choice)
             */
            hide_championship_dropdown: {
                codename: 'hide_championship_dropdown',
                id: '9d3e683a-c0b1-4fd3-a48d-89a2a9a8535c',
                externalId: undefined,
                name: 'Hide Championship Dropdown',
                required: false,
                type: 'multiple_choice',
                options: {
                    true: {
                        name: 'Yes',
                        id: 'c598de10-ff48-4eb8-a154-1b2573561b39',
                        codename: 'true',
                        externalId: undefined
                    },
                    false: {
                        name: 'No',
                        id: '0b5daa04-1abf-425a-bb6c-49d1d67d6250',
                        codename: 'false',
                        externalId: undefined
                    }
                }
            },

            /**
             * Hide My Account (multiple_choice)
             */
            hide_my_account: {
                codename: 'hide_my_account',
                id: '3d8d68a8-da7e-4fc3-89bd-fe8347a52651',
                externalId: undefined,
                name: 'Hide My Account',
                required: false,
                type: 'multiple_choice',
                options: {
                    true: {
                        name: 'Yes',
                        id: 'c135b2b3-80d9-4b0d-bf83-eef0285af52b',
                        codename: 'true',
                        externalId: undefined
                    },
                    false: {
                        name: 'No',
                        id: '7d1f2137-700d-4913-8c48-8ce087967703',
                        codename: 'false',
                        externalId: undefined
                    }
                }
            },

            /**
             * Mobile Logo (modular_content)
             */
            mobile_logo: {
                codename: 'mobile_logo',
                id: '15b85cff-cfad-4b2f-9bad-2b4648cb6f65',
                externalId: undefined,
                name: 'Mobile Logo',
                required: false,
                type: 'modular_content'
            },

            /**
             * Navigation (modular_content)
             */
            navigation: {
                codename: 'navigation',
                id: '3b2f15ba-4c2a-4da5-99fb-0aaed2b7e061',
                externalId: undefined,
                name: 'Navigation',
                required: false,
                type: 'modular_content'
            },

            /**
             * Title (modular_content)
             */
            title: {
                codename: 'title',
                id: '1273fc43-1184-42b2-b92f-96ae39a22533',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'modular_content'
            }
        }
    },

    /**
     * Hero Banner
     */
    hero_banner: {
        codename: 'hero_banner',
        id: '167cf9f4-8ff3-48e2-937e-ceb4ad44325e',
        externalId: undefined,
        name: 'Hero Banner',
        elements: {
            /**
             * Buttons (modular_content)
             */
            buttons: {
                codename: 'buttons',
                id: '403792df-e513-40d8-913f-7da88156ed65',
                externalId: undefined,
                name: 'Buttons',
                required: false,
                type: 'modular_content'
            },

            /**
             * Description (text)
             */
            description: {
                codename: 'description',
                id: 'cf78f287-7c2c-4b4a-aef1-cf2975c11277',
                externalId: undefined,
                name: 'Description',
                required: false,
                type: 'text'
            },

            /**
             * Desktop Background Image (asset)
             */
            desktop_background_image: {
                codename: 'desktop_background_image',
                id: '149d8f75-6baf-4258-9e23-61aee07be424',
                externalId: undefined,
                name: 'Desktop Background Image',
                required: false,
                type: 'asset'
            },

            /**
             * Mobile Background Image (asset)
             */
            mobile_background_image: {
                codename: 'mobile_background_image',
                id: '60e6bc8f-399d-4f13-b589-12f7b821d62d',
                externalId: undefined,
                name: 'Mobile Background Image',
                required: false,
                type: 'asset'
            },

            /**
             * Subtitle (text)
             *
             * A 25-character limit is recommended
             */
            subtitle: {
                codename: 'subtitle',
                id: '8fdc4954-ec72-418c-9c63-b284807c64f3',
                externalId: undefined,
                name: 'Subtitle',
                required: false,
                type: 'text'
            },

            /**
             * Title (text)
             *
             * A 25-character limit is recommended
             */
            title: {
                codename: 'title',
                id: '55d32eeb-8f4c-4c4c-97a0-984acba0a7aa',
                externalId: undefined,
                name: 'Title',
                required: true,
                type: 'text'
            }
        }
    },

    /**
     * Hero Banner Button
     */
    hero_banner_button: {
        codename: 'hero_banner_button',
        id: '7c6f2583-daf6-4752-87dd-ad910bff1ffc',
        externalId: undefined,
        name: 'Hero Banner Button',
        elements: {
            /**
             * Link (modular_content)
             */
            link: {
                codename: 'link',
                id: '751a79b2-7f5b-4b30-b6a6-d03ec58deafc',
                externalId: undefined,
                name: 'Link',
                required: false,
                type: 'modular_content'
            },

            /**
             * Text (text)
             */
            text: {
                codename: 'text',
                id: '4d02ef70-bc87-4d39-9102-5cac3a0228b8',
                externalId: undefined,
                name: 'Text',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * ID Card
     */
    player_portals_id_card: {
        codename: 'player_portals_id_card',
        id: '0ceaf99f-6f30-4f79-91d5-4d00583bc4ce',
        externalId: undefined,
        name: 'ID Card',
        elements: {
            /**
             * Caddie Label (text)
             */
            caddie_label: {
                codename: 'caddie_label',
                id: 'dbf0a93b-af41-4fe6-899f-65971ac42e0b',
                externalId: undefined,
                name: 'Caddie Label',
                required: false,
                type: 'text'
            },

            /**
             * Greeting Message (text)
             */
            greeting_message: {
                codename: 'greeting_message',
                id: 'f9a9b4b8-5657-44ca-9bc3-40b944f72449',
                externalId: undefined,
                name: 'Greeting Message',
                required: false,
                type: 'text'
            },

            /**
             * Manager Label (text)
             */
            manager_label: {
                codename: 'manager_label',
                id: '593ca0d0-b05c-4f8d-a17a-aa526124f25e',
                externalId: undefined,
                name: 'Manager Label',
                required: false,
                type: 'text'
            },

            /**
             * Player Label (text)
             */
            player_label: {
                codename: 'player_label',
                id: 'e19605b3-5b0a-4468-aa54-71286649fea4',
                externalId: undefined,
                name: 'Player Label',
                required: false,
                type: 'text'
            },

            /**
             * Players Number Label (text)
             */
            players_number_label: {
                codename: 'players_number_label',
                id: 'fcf5400a-e8d5-4564-a2a3-231b9434c5df',
                externalId: undefined,
                name: 'Players Number Label',
                required: false,
                type: 'text'
            },

            /**
             * Roles (taxonomy)
             */
            roles: {
                codename: 'roles',
                id: 'dfcf8e58-b87f-4453-974b-3ffeb0f92bc9',
                externalId: undefined,
                name: 'Roles',
                required: false,
                type: 'taxonomy'
            },

            /**
             * Theme (multiple_choice)
             */
            theme: {
                codename: 'theme',
                id: 'ddbea247-85e5-45dc-80b9-a0218b79cf6b',
                externalId: undefined,
                name: 'Theme',
                required: false,
                type: 'multiple_choice',
                options: {
                    light: {
                        name: 'light',
                        id: 'f3155057-cac0-44f7-8a4d-fbf9baaada44',
                        codename: 'light',
                        externalId: undefined
                    },
                    dark: {
                        name: 'dark',
                        id: 'be45bd45-9671-482d-bd8f-f5f82372321d',
                        codename: 'dark',
                        externalId: undefined
                    }
                }
            }
        }
    },

    /**
     * IFrame
     */
    iframe: {
        codename: 'iframe',
        id: '158f65fc-6758-4d9f-8de6-b8301851a7fc',
        externalId: undefined,
        name: 'IFrame',
        elements: {
            /**
             * Height (number)
             *
             * Enter a value in pixels or leave blank for auto height
             */
            height: {
                codename: 'height',
                id: 'cf136031-fe0a-4279-8165-27ba9c41eb4b',
                externalId: undefined,
                name: 'Height',
                required: false,
                type: 'number'
            },

            /**
             * Src (text)
             */
            src: {
                codename: 'src',
                id: '71d4fb34-affd-4ea9-8709-936a5b61a3b0',
                externalId: undefined,
                name: 'Src',
                required: true,
                type: 'text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'bf02e5ba-5bec-49e3-8523-e99dd582e398',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            },

            /**
             * Width (number)
             *
             * If no value is provided the iframe will take the parent container's width
             */
            width: {
                codename: 'width',
                id: 'c2a5afc1-8f5c-4e6c-a4d8-c78acc065474',
                externalId: undefined,
                name: 'Width',
                required: false,
                type: 'number'
            },

            /**
             * Width Unit (multiple_choice)
             *
             * Takes effect only when "Width" is set
             */
            width_unit: {
                codename: 'width_unit',
                id: '8c925125-dc9e-4d10-a266-f83e59d430b9',
                externalId: undefined,
                name: 'Width Unit',
                required: false,
                type: 'multiple_choice',
                options: {
                    px: {
                        name: 'px',
                        id: 'c0806776-f6b0-4a2f-92be-4f2a9236a909',
                        codename: 'px',
                        externalId: undefined
                    },
                    percent: {
                        name: ' ',
                        id: 'b7520fc6-a437-42b3-8515-60e8eb38ebbb',
                        codename: 'percent',
                        externalId: undefined
                    }
                }
            }
        }
    },

    /**
     * Image
     */
    image: {
        codename: 'image',
        id: 'e7695c96-401b-460b-bcf6-92ff8bfc35b0',
        externalId: undefined,
        name: 'Image',
        elements: {
            /**
             * Alt (text)
             */
            alt: {
                codename: 'alt',
                id: '05989566-2c29-4904-806c-be4bcd06c137',
                externalId: undefined,
                name: 'Alt',
                required: false,
                type: 'text'
            },

            /**
             * Asset (asset)
             */
            asset: {
                codename: 'asset',
                id: 'ea891b8d-93ee-4d36-b96c-1b0f1dafdaaf',
                externalId: undefined,
                name: 'Asset',
                required: true,
                type: 'asset'
            },

            /**
             * Height (number)
             */
            height: {
                codename: 'height',
                id: '695b9df3-0841-4c8f-842c-cbdad28ec869',
                externalId: undefined,
                name: 'Height',
                required: false,
                type: 'number'
            },

            /**
             * License (text)
             */
            license: {
                codename: 'license',
                id: '1679dabf-acd0-4358-aa84-f1a97ee095d8',
                externalId: undefined,
                name: 'License',
                required: false,
                type: 'text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'e5048576-2974-4b2f-bedf-dc5963d30bc3',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            },

            /**
             * Width (number)
             */
            width: {
                codename: 'width',
                id: 'b54f423d-9ec9-4b79-9920-886c6aa69484',
                externalId: undefined,
                name: 'Width',
                required: false,
                type: 'number'
            }
        }
    },

    /**
     * Link
     */
    link: {
        codename: 'link',
        id: '9fb5b11c-e2f5-49a3-a6e6-37fe634b7bf7',
        externalId: undefined,
        name: 'Link',
        elements: {
            /**
             * href (text)
             *
             * Use this property when reffering to an external page
             */
            href: {
                codename: 'href',
                id: '93fc62ef-708b-479f-8505-87a4d50dc72e',
                externalId: undefined,
                name: 'href',
                required: false,
                type: 'text'
            },

            /**
             * Icon (asset)
             */
            icon: {
                codename: 'icon',
                id: '12eccf2a-9b64-4634-8124-a8f184f4c97a',
                externalId: undefined,
                name: 'Icon',
                required: false,
                type: 'asset'
            },

            /**
             * Internal page (modular_content)
             */
            internal_page: {
                codename: 'internal_page',
                id: 'b4ff30b5-4ea6-4b1f-b0f9-ed094f7e17df',
                externalId: undefined,
                name: 'Internal page',
                required: false,
                type: 'modular_content'
            },

            /**
             * Internal page path (text)
             *
             * Use this property when you want to use the content item as link to a page contained in multiple collections.Note: the value should start with "/"
             */
            internal_page_path: {
                codename: 'internal_page_path',
                id: 'c1f9c2ff-41e0-4644-870c-0105304be8ac',
                externalId: undefined,
                name: 'Internal page path',
                required: false,
                type: 'text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '0c218970-c833-4df8-8e9b-3fd2a77f7c30',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Logo
     */
    logo: {
        codename: 'logo',
        id: 'bff06bfe-fca5-4c44-8953-92a53d7d36b1',
        externalId: undefined,
        name: 'Logo',
        elements: {
            /**
             * Logo Image (asset)
             */
            logo_image: {
                codename: 'logo_image',
                id: 'a5131714-ff62-43a3-9e83-bdf598c3802e',
                externalId: undefined,
                name: 'Logo Image',
                required: true,
                type: 'asset'
            },

            /**
             * Mobile Logo Image (asset)
             *
             * If this element is empty the Logo Image will be displayed.
             */
            mobile_logo_image: {
                codename: 'mobile_logo_image',
                id: '24eadd1a-5838-42d2-ac93-f243500fd156',
                externalId: undefined,
                name: 'Mobile Logo Image',
                required: false,
                type: 'asset'
            },

            /**
             * Resources (modular_content)
             */
            resources: {
                codename: 'resources',
                id: 'f9096730-65ed-44aa-b31f-58122e0f882d',
                externalId: undefined,
                name: 'Resources',
                required: true,
                type: 'modular_content'
            }
        }
    },

    /**
     * Menu
     */
    player_portals_menu: {
        codename: 'player_portals_menu',
        id: '5c873c28-d44e-47ac-b186-c3818ab00d0f',
        externalId: undefined,
        name: 'Menu',
        elements: {
            /**
             * Burger Menu Id Card (modular_content)
             */
            burger_menu_id_card: {
                codename: 'burger_menu_id_card',
                id: 'b8b8c345-4083-45ad-949b-eff85a2126de',
                externalId: undefined,
                name: 'Burger Menu Id Card',
                required: false,
                type: 'modular_content'
            },

            /**
             * Menu Items (modular_content)
             *
             * These can be links to internal/external pages and also submenus
             */
            menu_items: {
                codename: 'menu_items',
                id: 'e18ed292-bebb-4a12-aa30-3e2b76845840',
                externalId: undefined,
                name: 'Menu Items',
                required: false,
                type: 'modular_content'
            },

            /**
             * Roles (taxonomy)
             *
             * For the parent menu all roles should remain unselected
             */
            roles: {
                codename: 'roles',
                id: '02e9c852-6d9c-4c1f-a1d0-3160ae4b6e56',
                externalId: undefined,
                name: 'Roles',
                required: false,
                type: 'taxonomy'
            },

            /**
             * Title (text)
             *
             * This is the text that appears if it is not the root of the menu
             */
            title: {
                codename: 'title',
                id: 'b78abf90-e97d-4a75-b96f-1c3e075525f5',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * My Claude Component
     */
    my_claude_component: {
        codename: 'my_claude_component',
        id: 'd0f688ba-a80d-4e62-8be3-c563a3ba10f0',
        externalId: undefined,
        name: 'My Claude Component',
        elements: {
            /**
             * Description (text)
             */
            description: {
                codename: 'description',
                id: '9c9ab59d-ca9e-45bd-b084-f87480a4ee40',
                externalId: undefined,
                name: 'Description',
                required: false,
                type: 'text'
            },

            /**
             * Linked Items   Multiple (modular_content)
             */
            linked_items___multiple: {
                codename: 'linked_items___multiple',
                id: '6b9c3a4b-d383-49c9-b1e1-44f00fff491d',
                externalId: undefined,
                name: 'Linked Items - Multiple',
                required: false,
                type: 'modular_content'
            },

            /**
             * Linked Items   Single Choice (modular_content)
             */
            linked_items___single_choice: {
                codename: 'linked_items___single_choice',
                id: '74e583d0-51d4-4156-8ae7-3b2c72cb4638',
                externalId: undefined,
                name: 'Linked Items - Single Choice',
                required: false,
                type: 'modular_content'
            },

            /**
             * Multiple Choice (multiple_choice)
             */
            multiple_choice: {
                codename: 'multiple_choice',
                id: 'cb794b5f-7285-4967-90fd-ac8b2da50985',
                externalId: undefined,
                name: 'Multiple Choice',
                required: false,
                type: 'multiple_choice',
                options: {
                    option_1: {
                        name: 'Option 1',
                        id: '311920d1-1ce1-4753-b2d3-ea2e22ff976e',
                        codename: 'option_1',
                        externalId: undefined
                    },
                    option_2: {
                        name: 'Option 2',
                        id: '8850a8eb-a14e-4d9b-908d-8e17c087f483',
                        codename: 'option_2',
                        externalId: undefined
                    },
                    option_3: {
                        name: 'Option 3',
                        id: 'bebc5a4b-c140-4464-9367-e795b75ce7cd',
                        codename: 'option_3',
                        externalId: undefined
                    },
                    option_4: {
                        name: 'Option 4',
                        id: '58afea0d-259f-43db-8b0e-f365cfc5bc98',
                        codename: 'option_4',
                        externalId: undefined
                    },
                    option_5: {
                        name: 'Option 5',
                        id: 'f735c4a6-26a1-4af9-9676-7d92e85cbf52',
                        codename: 'option_5',
                        externalId: undefined
                    }
                }
            },

            /**
             * Single Choice (multiple_choice)
             */
            single_choice: {
                codename: 'single_choice',
                id: 'cc7bf5d9-e53a-42e9-b755-2bf5d305addb',
                externalId: undefined,
                name: 'Single Choice',
                required: false,
                type: 'multiple_choice',
                options: {
                    type_1: {
                        name: 'Type 1',
                        id: '8dde19eb-e545-4110-828c-9345f68142d7',
                        codename: 'type_1',
                        externalId: undefined
                    },
                    type_2: {
                        name: 'Type 2',
                        id: '9a6bb226-4195-43c7-94e5-fdfaf48385d8',
                        codename: 'type_2',
                        externalId: undefined
                    },
                    type_3: {
                        name: 'Type 3',
                        id: 'd8bfd6ef-5080-460d-8d74-84494c051f27',
                        codename: 'type_3',
                        externalId: undefined
                    },
                    type_4: {
                        name: 'Type 4',
                        id: 'f1506f85-9ef1-484a-b1e2-641921571e64',
                        codename: 'type_4',
                        externalId: undefined
                    }
                }
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '29032a8b-2908-403c-9112-b360712a9979',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * On Site Registration Admin Panel
     */
    player_portals_on_site_registration_admin_panel: {
        codename: 'player_portals_on_site_registration_admin_panel',
        id: 'd1a44c91-9d50-4d5b-844f-beed35ec8ec8',
        externalId: undefined,
        name: 'On Site Registration Admin Panel',
        elements: {
            /**
             * Agree To Policies Button Label (text)
             */
            agree_to_policies_button_label: {
                codename: 'agree_to_policies_button_label',
                id: 'fd638d59-8308-4b3d-b789-a3579a7c3551',
                externalId: undefined,
                name: 'Agree To Policies Button Label',
                required: true,
                type: 'text'
            },

            /**
             * Anti Betting Policy Text (text)
             */
            anti_betting_policy_text: {
                codename: 'anti_betting_policy_text',
                id: '5c153a12-04c7-4df8-9152-1a02a4aeee19',
                externalId: undefined,
                name: 'Anti-Betting Policy Text',
                required: false,
                type: 'text'
            },

            /**
             * Anti Doping Policy Text (text)
             */
            anti_doping_policy_text: {
                codename: 'anti_doping_policy_text',
                id: '55b64bc4-62e0-4ac6-a9b3-a041e324fab3',
                externalId: undefined,
                name: 'Anti-Doping Policy Text',
                required: false,
                type: 'text'
            },

            /**
             * Complete Registration Button Label (text)
             */
            complete_registration_button_label: {
                codename: 'complete_registration_button_label',
                id: '3b25775d-7137-4749-a67e-03a86bdd15da',
                externalId: undefined,
                name: 'Complete Registration Button Label',
                required: true,
                type: 'text'
            },

            /**
             * Create Caddie Form (modular_content)
             *
             * Use this field only for "Caddies" datasource
             */
            create_caddie_form: {
                codename: 'create_caddie_form',
                id: '51ae6a5e-2e3f-40d9-9039-ec946e9c3058',
                externalId: undefined,
                name: 'Create Caddie Form',
                required: false,
                type: 'modular_content'
            },

            /**
             * Data Filled In And Not Registered Label (text)
             */
            data_filled_in_and_not_registered_label: {
                codename: 'data_filled_in_and_not_registered_label',
                id: '4d1a30d9-f0e5-411f-bfc9-309e26798fa4',
                externalId: undefined,
                name: 'Data Filled In And Not Registered Label',
                required: true,
                type: 'text'
            },

            /**
             * Data Source (multiple_choice)
             */
            data_source: {
                codename: 'data_source',
                id: '2591dea1-c090-40d1-9033-ea49fe96bda1',
                externalId: undefined,
                name: 'Data Source',
                required: true,
                type: 'multiple_choice',
                options: {
                    players: {
                        name: 'Players',
                        id: '70ae7d08-06f6-43a6-9f7e-e8a117aac02a',
                        codename: 'players',
                        externalId: undefined
                    },
                    caddies: {
                        name: 'Caddies',
                        id: '9830fbb7-08de-45b5-9550-848d2dfe1d23',
                        codename: 'caddies',
                        externalId: undefined
                    }
                }
            },

            /**
             * Email Callback Url (modular_content)
             */
            email_callback_url: {
                codename: 'email_callback_url',
                id: '1d26ffb7-4728-4c10-808e-52a0d6e86936',
                externalId: undefined,
                name: 'Email Callback Url',
                required: false,
                type: 'modular_content'
            },

            /**
             * Email From (text)
             */
            email_from: {
                codename: 'email_from',
                id: 'a7e2d206-f432-46e1-aad7-9f9da7f2dba0',
                externalId: undefined,
                name: 'Email From',
                required: false,
                type: 'text'
            },

            /**
             * Email Reply To (text)
             */
            email_reply_to: {
                codename: 'email_reply_to',
                id: '31c609a9-dc6c-495f-9fa9-df696a729b3a',
                externalId: undefined,
                name: 'Email Reply To',
                required: false,
                type: 'text'
            },

            /**
             * Email Subject (text)
             */
            email_subject: {
                codename: 'email_subject',
                id: '3cf8e558-399e-4603-9997-e8d91f57df2a',
                externalId: undefined,
                name: 'Email Subject',
                required: false,
                type: 'text'
            },

            /**
             * Email Template Name (text)
             */
            email_template_name: {
                codename: 'email_template_name',
                id: '24bb4225-d20d-4a25-820f-85d10d5a7976',
                externalId: undefined,
                name: 'Email Template Name',
                required: false,
                type: 'text'
            },

            /**
             * Not Registered Label (text)
             */
            not_registered_label: {
                codename: 'not_registered_label',
                id: '4466bad0-df5a-47e4-a062-344bf67e32a9',
                externalId: undefined,
                name: 'Not Registered Label',
                required: true,
                type: 'text'
            },

            /**
             * Participants Page Size (number)
             *
             * Choose how many participant cards to be displayed on a single page
             */
            participants_page_size: {
                codename: 'participants_page_size',
                id: '9dc27a22-a42c-416b-9ecf-b268f3296703',
                externalId: undefined,
                name: 'Participants Page Size',
                required: false,
                type: 'number'
            },

            /**
             * Policy Acceptance Section Title (text)
             */
            policy_acceptance_section_title: {
                codename: 'policy_acceptance_section_title',
                id: '2167ab7b-a062-43a2-8179-aceed193bef7',
                externalId: undefined,
                name: 'Policy Acceptance Section Title',
                required: true,
                type: 'text'
            },

            /**
             * Privacy Policy Section Text (rich_text)
             */
            privacy_policy_section_text: {
                codename: 'privacy_policy_section_text',
                id: '33b5d188-6834-4dd0-a972-8214bee2a1f5',
                externalId: undefined,
                name: 'Privacy Policy Section Text',
                required: false,
                type: 'rich_text'
            },

            /**
             * Re send Email Button Label (text)
             */
            re_send_email_button_label: {
                codename: 're_send_email_button_label',
                id: '8a0252e2-69b1-4a7e-9fbb-e96c1dd089e7',
                externalId: undefined,
                name: 'Re-send Email Button Label',
                required: true,
                type: 'text'
            },

            /**
             * Re send SMS Button Label (text)
             */
            re_send_sms_button_label: {
                codename: 're_send_sms_button_label',
                id: 'bbe27473-fad0-4305-8c62-b2e569e8e641',
                externalId: undefined,
                name: 'Re-send SMS Button Label',
                required: true,
                type: 'text'
            },

            /**
             * Registered Label (text)
             */
            registered_label: {
                codename: 'registered_label',
                id: '1178ee50-11b0-45b4-932a-7475559610ac',
                externalId: undefined,
                name: 'Registered Label',
                required: true,
                type: 'text'
            },

            /**
             * Registration Form (modular_content)
             */
            registration_form: {
                codename: 'registration_form',
                id: '9edcf797-a894-4d11-a8f6-80ba2514d1bc',
                externalId: undefined,
                name: 'Registration Form',
                required: true,
                type: 'modular_content'
            },

            /**
             * SMS Callback Url (modular_content)
             */
            sms_callback_url: {
                codename: 'sms_callback_url',
                id: '21ac8a99-09d3-4522-b2a9-fa62231c050d',
                externalId: undefined,
                name: 'SMS Callback Url',
                required: false,
                type: 'modular_content'
            },

            /**
             * SMS From (text)
             */
            sms_from: {
                codename: 'sms_from',
                id: 'bbd47a9d-2237-499d-84fd-31a8e1833260',
                externalId: undefined,
                name: 'SMS From',
                required: false,
                type: 'text'
            },

            /**
             * SMS Template Sid (text)
             */
            sms_template_sid: {
                codename: 'sms_template_sid',
                id: '62fd8834-a65c-45a4-bb6a-9219568991b1',
                externalId: undefined,
                name: 'SMS Template Sid',
                required: false,
                type: 'text'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'a68e0cfb-781d-4b9b-ab6b-c2d14c8f6233',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Option
     */
    player_portals_option: {
        codename: 'player_portals_option',
        id: 'c4c97bdf-886d-484c-85b9-dbb61b463ea8',
        externalId: undefined,
        name: 'Option',
        elements: {
            /**
             * Font Awesome Icon (text)
             *
             * Choose a valid Font Awesome icon definition: e.g: fork-knife
             */
            font_awesome_icon: {
                codename: 'font_awesome_icon',
                id: '315115bd-e0f2-4ad3-8056-4c018d6bf83c',
                externalId: undefined,
                name: 'Font Awesome Icon',
                required: false,
                type: 'text'
            },

            /**
             * Id (text)
             */
            id: {
                codename: 'id',
                id: 'f8ba5e9d-7901-4cba-995f-c3ad21794a39',
                externalId: undefined,
                name: 'Id',
                required: false,
                type: 'text'
            },

            /**
             * Name (text)
             */
            name: {
                codename: 'name',
                id: '1c411f6f-a22d-4529-9a06-7fa02b9eef0d',
                externalId: undefined,
                name: 'Name',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Option With Disabled
     */
    option_with_disabled: {
        codename: 'option_with_disabled',
        id: '064fa9d4-1aee-4d06-ac2d-66b5c393e130',
        externalId: undefined,
        name: 'Option With Disabled',
        elements: {
            /**
             * Font Awesome icon (text)
             *
             * Choose a valid Font Awesome icon definition: e.g: fork-knife
             */
            font_awesome_icon: {
                codename: 'font_awesome_icon',
                id: 'f516e3dc-0bdf-43fb-8c5a-beb5a3f4e579',
                externalId: undefined,
                name: 'Font Awesome icon',
                required: false,
                type: 'text'
            },

            /**
             * Id (text)
             */
            id: {
                codename: 'id',
                id: '780169cd-fa0d-4a4c-bce8-946da6f3c851',
                externalId: undefined,
                name: 'Id',
                required: false,
                type: 'text'
            },

            /**
             * Is Disabled (multiple_choice)
             */
            is_disabled: {
                codename: 'is_disabled',
                id: '083d138b-3088-4443-969d-a29f21697c3e',
                externalId: undefined,
                name: 'Is Disabled',
                required: false,
                type: 'multiple_choice',
                options: {
                    true: {
                        name: 'True',
                        id: 'd9183d03-2cbc-48f6-8518-c17eefa842ad',
                        codename: 'true',
                        externalId: undefined
                    }
                }
            },

            /**
             * Name (text)
             */
            name: {
                codename: 'name',
                id: '22ae6d17-424a-4b85-ac7b-e8f3c32f4ccc',
                externalId: undefined,
                name: 'Name',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Option with Rich Text
     */
    option_with_rich_text: {
        codename: 'option_with_rich_text',
        id: 'd2ee0c64-a77c-42e0-8afd-039be807720c',
        externalId: undefined,
        name: 'Option with Rich Text',
        elements: {
            /**
             * Description (rich_text)
             */
            description: {
                codename: 'description',
                id: 'c59375ba-7c52-4e11-b98e-2c513498c20b',
                externalId: undefined,
                name: 'Description',
                required: false,
                type: 'rich_text'
            },

            /**
             * Value (text)
             */
            value: {
                codename: 'value',
                id: '41b4090b-28af-4823-bcfa-ec55a19f12fa',
                externalId: undefined,
                name: 'Value',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Page
     */
    player_portals_page: {
        codename: 'player_portals_page',
        id: '4ab17b92-2d81-4d86-a1d7-a25d5d981f6a',
        externalId: undefined,
        name: 'Page',
        elements: {
            /**
             * Body (modular_content)
             */
            body: {
                codename: 'body',
                id: '5b6d65c5-db50-4683-ba09-88e19e464ac8',
                externalId: undefined,
                name: 'Body',
                required: false,
                type: 'modular_content'
            },

            /**
             * Keywords (text)
             */
            seo__key_words: {
                codename: 'seo__key_words',
                id: 'd5406280-ee99-459f-bebd-2f3794765acd',
                externalId: undefined,
                name: 'Keywords',
                required: false,
                type: 'text',

                snippetCodename: 'seo'
            },

            /**
             * Meta Description (text)
             */
            seo__meta_description: {
                codename: 'seo__meta_description',
                id: '69b9ad12-66e7-4b64-92ef-389ba8cb33d8',
                externalId: undefined,
                name: 'Meta Description',
                required: false,
                type: 'text',

                snippetCodename: 'seo'
            },

            /**
             * Meta Title (text)
             */
            seo__meta_title: {
                codename: 'seo__meta_title',
                id: 'f3ef17b6-0bd4-4c1f-8e16-79d66bcb6f1f',
                externalId: undefined,
                name: 'Meta Title',
                required: true,
                type: 'text',

                snippetCodename: 'seo'
            },

            /**
             * No Follow (multiple_choice)
             */
            seo__no_follow: {
                codename: 'seo__no_follow',
                id: 'f3bbb042-2cfa-4bf2-ad97-9a4756c45275',
                externalId: undefined,
                name: 'No Follow',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: 'ed0f2d7d-e5ea-43d2-8be0-5e2b62bb8733',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: 'dba27b75-0e3e-4f06-809c-1f7ea64cdb07',
                        codename: 'no',
                        externalId: undefined
                    }
                },
                snippetCodename: 'seo'
            },

            /**
             * No Index (multiple_choice)
             */
            seo__no_index: {
                codename: 'seo__no_index',
                id: '298ecfd0-51b9-4680-bb29-bb722456d928',
                externalId: undefined,
                name: 'No Index',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: 'f70421a8-4dce-4eb4-9c8d-840a32006a86',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: 'bd5bff7b-099e-4221-a1d8-0b29f3cfc696',
                        codename: 'no',
                        externalId: undefined
                    }
                },
                snippetCodename: 'seo'
            },

            /**
             * Pre footer elements (modular_content)
             */
            pre_footer_elements: {
                codename: 'pre_footer_elements',
                id: 'ebaa05d7-e3be-4784-9b5e-d2f3b786661d',
                externalId: undefined,
                name: 'Pre footer elements',
                required: false,
                type: 'modular_content'
            },

            /**
             * Roles (taxonomy)
             */
            roles: {
                codename: 'roles',
                id: '15ddf198-d201-4f6b-8dc5-ff0c44adbfc9',
                externalId: undefined,
                name: 'Roles',
                required: false,
                type: 'taxonomy'
            },

            /**
             * Sidebar (modular_content)
             */
            sidebar: {
                codename: 'sidebar',
                id: 'a8ec8e19-0807-426a-a181-7f8e87e82396',
                externalId: undefined,
                name: 'Sidebar',
                required: false,
                type: 'modular_content'
            },

            /**
             * Special URL (text)
             *
             * WARNING: IF THERE ARE TWO PAGES WITH THE SAME SPECIAL URL, THE OUTCOME OF THE SEARCH WILL BE UNPREDICTABLE.
             */
            special_url: {
                codename: 'special_url',
                id: '468785a5-deb5-4d4c-92c4-62a945778c4f',
                externalId: undefined,
                name: 'Special URL',
                required: false,
                type: 'text'
            },

            /**
             * Subheader elements (modular_content)
             */
            subheader_elements: {
                codename: 'subheader_elements',
                id: '0f20959f-5184-4665-b683-0f40effa6a81',
                externalId: undefined,
                name: 'Subheader elements',
                required: false,
                type: 'modular_content'
            },

            /**
             * Template (modular_content)
             */
            template: {
                codename: 'template',
                id: '30d96e97-55c6-4efd-95e3-1646c3b02f47',
                externalId: undefined,
                name: 'Template',
                required: true,
                type: 'modular_content'
            },

            /**
             * URL slug (url_slug)
             */
            url_slug: {
                codename: 'url_slug',
                id: '5f355412-ca41-4035-9531-c16b877b3d5c',
                externalId: undefined,
                name: 'URL slug',
                required: true,
                type: 'url_slug'
            }
        }
    },

    /**
     * Page template
     */
    player_portals_page_template: {
        codename: 'player_portals_page_template',
        id: '95b065f8-30e6-495a-98b5-d3e08199c381',
        externalId: undefined,
        name: 'Page template',
        elements: {
            /**
             * Footer (modular_content)
             */
            footer: {
                codename: 'footer',
                id: '5e204047-e91a-4be9-baef-af51b7fb5992',
                externalId: undefined,
                name: 'Footer',
                required: true,
                type: 'modular_content'
            },

            /**
             * Header (modular_content)
             */
            header: {
                codename: 'header',
                id: '22b23c8c-d4b1-4100-8872-b4efb74e6ccf',
                externalId: undefined,
                name: 'Header',
                required: true,
                type: 'modular_content'
            },

            /**
             * Roles (taxonomy)
             */
            roles: {
                codename: 'roles',
                id: '3d184d0d-89ae-4d64-a2bc-6d148db7d38b',
                externalId: undefined,
                name: 'Roles',
                required: false,
                type: 'taxonomy'
            }
        }
    },

    /**
     * Player Portals Championship
     */
    player_portals_championship: {
        codename: 'player_portals_championship',
        id: 'a06dc838-9570-4a95-b034-edd799d934c5',
        externalId: undefined,
        name: 'Player Portals Championship',
        elements: {
            /**
             * Associated Kontent Collection (multiple_choice)
             */
            kontent_collections__associated_kontent_collection: {
                codename: 'kontent_collections__associated_kontent_collection',
                id: '536ba7f3-f346-4fc4-b1fc-ee0a2f4668be',
                externalId: undefined,
                name: 'Associated Kontent Collection',
                required: false,
                type: 'multiple_choice',
                options: {
                    player_portal___aig_women_s_open: {
                        name: 'Player Portal   AIG Women s Open',
                        id: 'f8580f25-cdea-42d8-8f32-e69761480096',
                        codename: 'player_portal___aig_women_s_open',
                        externalId: undefined
                    },
                    player_portal___the_open: {
                        name: 'Player Portal   The Open',
                        id: '7e5ad735-7fb2-4557-abfc-b38d4800df43',
                        codename: 'player_portal___the_open',
                        externalId: undefined
                    },
                    qualifying_portal: {
                        name: 'Qualifying Portal',
                        id: '96df6484-6976-4aae-bcfb-f55a286f0bd7',
                        codename: 'qualifying_portal',
                        externalId: undefined
                    },
                    default: {
                        name: 'Default',
                        id: '5f2e8b5e-8e49-41e4-b63d-c406490bfecf',
                        codename: 'default',
                        externalId: undefined
                    }
                },
                snippetCodename: 'kontent_collections'
            },

            /**
             * Championship Identifier (text)
             *
             * This represents the GUID of the championship as stored in the EMS system, specifically in the EMS Championship table.It is used to filter the list of championship players that an R&A administrator account is permitted to view and edit for the On-Site Registration.
             */
            championship_identifier: {
                codename: 'championship_identifier',
                id: '5957bb2a-0599-43ab-a328-07e0bad580bc',
                externalId: undefined,
                name: 'Championship Identifier',
                required: false,
                type: 'text'
            },

            /**
             * Landing Page (modular_content)
             */
            landing_page: {
                codename: 'landing_page',
                id: '5fe30bf2-56d7-451a-8a05-d31e6536c0d9',
                externalId: undefined,
                name: 'Landing Page',
                required: false,
                type: 'modular_content'
            },

            /**
             * Name (text)
             */
            name: {
                codename: 'name',
                id: 'd94ce2c3-e714-4b31-a8f6-f31990c58d68',
                externalId: undefined,
                name: 'Name',
                required: true,
                type: 'text'
            },

            /**
             * Website (text)
             */
            website: {
                codename: 'website',
                id: 'a1de23b4-2df5-4685-870d-6936c1b77862',
                externalId: undefined,
                name: 'Website',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Player Portals Configuration
     */
    player_portals_configuration: {
        codename: 'player_portals_configuration',
        id: '377a137a-0702-45de-bd69-554e13aa0eba',
        externalId: undefined,
        name: 'Player Portals Configuration',
        elements: {
            /**
             * Available Championships (modular_content)
             */
            available_championships: {
                codename: 'available_championships',
                id: '1d2b3d64-c139-4c72-91a2-229fc1718a84',
                externalId: undefined,
                name: 'Available Championships',
                required: true,
                type: 'modular_content'
            },

            /**
             * Cookie Settings (modular_content)
             */
            cookie_settings: {
                codename: 'cookie_settings',
                id: 'f3308cc8-36bc-4397-a864-a6a17d136e17',
                externalId: undefined,
                name: 'Cookie Settings',
                required: false,
                type: 'modular_content'
            },

            /**
             * Cookies Popup (modular_content)
             */
            cookie_popup: {
                codename: 'cookie_popup',
                id: '6c3ea19d-e676-4e0a-9ed2-36d6eeab5ddf',
                externalId: undefined,
                name: 'Cookies Popup',
                required: false,
                type: 'modular_content'
            },

            /**
             * Landing Page (modular_content)
             */
            landing_page: {
                codename: 'landing_page',
                id: 'd9256923-6628-42b0-8e3a-ebf6dcb96405',
                externalId: undefined,
                name: 'Landing Page',
                required: false,
                type: 'modular_content'
            }
        }
    },

    /**
     * Pre Registration Manager Panel
     */
    pre_registration_manager_panel: {
        codename: 'pre_registration_manager_panel',
        id: '20fa63f2-3092-4ef7-921c-5cc7b41d4a1c',
        externalId: undefined,
        name: 'Pre Registration Manager Panel',
        elements: {
            /**
             * Form Component (modular_content)
             */
            form_component: {
                codename: 'form_component',
                id: '47783783-bb17-48c9-b285-4f001c923fba',
                externalId: undefined,
                name: 'Form Component',
                required: false,
                type: 'modular_content'
            },

            /**
             * Resource (modular_content)
             */
            resource: {
                codename: 'resource',
                id: '707dccc6-2912-429a-b1fd-e15ac7ffe397',
                externalId: undefined,
                name: 'Resource',
                required: false,
                type: 'modular_content'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: '3949ca29-928f-44b5-b745-64c68ffdeba7',
                externalId: undefined,
                name: 'Title',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Query Param
     */
    query_param: {
        codename: 'query_param',
        id: '93ee7906-2d58-4a6e-8659-f0593ec45a88',
        externalId: undefined,
        name: 'Query Param',
        elements: {
            /**
             * Value (text)
             */
            value: {
                codename: 'value',
                id: 'b22b999a-56ba-4d16-b317-2d7bea4fd6fe',
                externalId: undefined,
                name: 'Value',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Regex Validation
     */
    regex_validation: {
        codename: 'regex_validation',
        id: '9ff1f19e-9721-441b-a8a5-a412fbc0d626',
        externalId: undefined,
        name: 'Regex Validation',
        elements: {
            /**
             * Regex (text)
             */
            regex: {
                codename: 'regex',
                id: 'ca9b2363-f14a-4a40-8af5-0a9ddae5780d',
                externalId: undefined,
                name: 'Regex',
                required: true,
                type: 'text'
            },

            /**
             * Validation Message (text)
             */
            validation_message: {
                codename: 'validation_message',
                id: 'd0b8afab-8861-4ab2-a104-f4d052568672',
                externalId: undefined,
                name: 'Validation Message',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Relation Item
     */
    relation_item: {
        codename: 'relation_item',
        id: '5565c4a6-e1dd-47d9-9aeb-04c68239adb0',
        externalId: undefined,
        name: 'Relation Item',
        elements: {
            /**
             * Relation (multiple_choice)
             */
            relation: {
                codename: 'relation',
                id: '17a97ee4-8aa4-4de8-bbd1-77de6ab1b374',
                externalId: undefined,
                name: 'Relation',
                required: false,
                type: 'multiple_choice',
                options: {
                    equals: {
                        name: 'Equals',
                        id: 'a8d72672-3cc5-450f-8283-de01275e36d0',
                        codename: 'equals',
                        externalId: undefined
                    },
                    less_than: {
                        name: 'Less Than',
                        id: 'd5345ffc-d886-4d28-bdfb-7ca67a5cc8e7',
                        codename: 'less_than',
                        externalId: undefined
                    },
                    greater_than: {
                        name: 'Greater Than',
                        id: 'b6b3f76e-965f-45a9-a684-afe3af80e52d',
                        codename: 'greater_than',
                        externalId: undefined
                    }
                }
            },

            /**
             * Value (text)
             */
            value: {
                codename: 'value',
                id: 'ecbe1455-31af-4376-8a0f-63d7fe1042fa',
                externalId: undefined,
                name: 'Value',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Rich Text
     */
    rich_text: {
        codename: 'rich_text',
        id: '4438a91d-6ba6-4c4f-91cd-f51ee8335693',
        externalId: undefined,
        name: 'Rich Text',
        elements: {
            /**
             * Content (rich_text)
             *
             * To add a link that triggers the Cookie Settings popup, use "#" as the link’s URL.
             */
            content: {
                codename: 'content',
                id: 'b0fe546f-0b59-4848-b92d-8caaa5ff8ed6',
                externalId: undefined,
                name: 'Content',
                required: true,
                type: 'rich_text'
            },

            /**
             * Text Size (multiple_choice)
             */
            text_size: {
                codename: 'text_size',
                id: '0c310140-2f4c-4203-bdf2-e49d4bd88d6b',
                externalId: undefined,
                name: 'Text Size',
                required: false,
                type: 'multiple_choice',
                options: {
                    regular: {
                        name: 'Regular',
                        id: 'eaf4ccfa-e964-469d-9e2f-ef4e5887cc4f',
                        codename: 'regular',
                        externalId: undefined
                    },
                    small: {
                        name: 'Small',
                        id: 'f44368fd-6b7a-4bf0-a704-1a00c0649101',
                        codename: 'small',
                        externalId: undefined
                    },
                    big: {
                        name: 'Big',
                        id: '50784a95-dc68-497b-b19e-0cb0138cefc6',
                        codename: 'big',
                        externalId: undefined
                    },
                    extra_big: {
                        name: 'Extra Big',
                        id: '0cbcade2-954b-4478-bf28-4a0c01804506',
                        codename: 'extra_big',
                        externalId: undefined
                    }
                }
            }
        }
    },

    /**
     * Rich Text with Asset
     */
    rich_text_with_asset: {
        codename: 'rich_text_with_asset',
        id: '78501046-0314-4d14-ae35-fffab26fb4f8',
        externalId: undefined,
        name: 'Rich Text with Asset',
        elements: {
            /**
             * Content (rich_text)
             */
            content: {
                codename: 'content',
                id: '9b4d42b0-8d1f-49c4-baa5-d25b79f76714',
                externalId: undefined,
                name: 'Content',
                required: false,
                type: 'rich_text'
            },

            /**
             * Desktop Image (asset)
             */
            desktop_image: {
                codename: 'desktop_image',
                id: '608bbdb9-2e7c-40fd-a654-3c2dde206501',
                externalId: undefined,
                name: 'Desktop Image',
                required: false,
                type: 'asset'
            },

            /**
             * Mobile Image (asset)
             */
            mobile_image: {
                codename: 'mobile_image',
                id: '83c72478-51e0-4b49-89f6-71de3fd3f9f3',
                externalId: undefined,
                name: 'Mobile Image',
                required: false,
                type: 'asset'
            },

            /**
             * Text Size (multiple_choice)
             */
            text_size: {
                codename: 'text_size',
                id: '01f39d34-fcff-4c6a-9558-408135eb276d',
                externalId: undefined,
                name: 'Text Size',
                required: false,
                type: 'multiple_choice',
                options: {
                    regular: {
                        name: 'Regular',
                        id: '2d3ee59a-9a33-460b-acd5-1c3ae131d6ed',
                        codename: 'regular',
                        externalId: undefined
                    },
                    small: {
                        name: 'Small',
                        id: '324119ad-f24b-4bbe-8553-9b91e8841bb8',
                        codename: 'small',
                        externalId: undefined
                    },
                    big: {
                        name: 'Big',
                        id: '8dfd36a5-f994-4198-b5dc-73b80fcdfa75',
                        codename: 'big',
                        externalId: undefined
                    },
                    extra_big: {
                        name: 'Extra Big',
                        id: '27290180-2f1a-409f-8326-92c734afd163',
                        codename: 'extra_big',
                        externalId: undefined
                    }
                }
            },

            /**
             * Url (text)
             */
            url: {
                codename: 'url',
                id: '86d419f3-ffa1-456e-a1d2-d09e3e334cfc',
                externalId: undefined,
                name: 'Url',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Section Title
     */
    section_title: {
        codename: 'section_title',
        id: 'e61bf38a-ff35-42d4-9737-3bdc00c23e5d',
        externalId: undefined,
        name: 'Section Title',
        elements: {
            /**
             * Background Image (asset)
             */
            background_image: {
                codename: 'background_image',
                id: '462d83ea-a9f8-48cf-af19-4b8a08691805',
                externalId: undefined,
                name: 'Background Image',
                required: false,
                type: 'asset'
            },

            /**
             * Title (text)
             */
            title: {
                codename: 'title',
                id: 'f92cb171-f66a-45da-8c96-a765c229c889',
                externalId: undefined,
                name: 'Title',
                required: true,
                type: 'text'
            }
        }
    },

    /**
     * SEO Data
     */
    seo_data: {
        codename: 'seo_data',
        id: '4b686643-ba91-44e4-aac0-b616a51e1737',
        externalId: undefined,
        name: 'SEO Data',
        elements: {
            /**
             * Keywords (text)
             */
            seo__key_words: {
                codename: 'seo__key_words',
                id: 'd5406280-ee99-459f-bebd-2f3794765acd',
                externalId: undefined,
                name: 'Keywords',
                required: false,
                type: 'text',

                snippetCodename: 'seo'
            },

            /**
             * Meta Description (text)
             */
            seo__meta_description: {
                codename: 'seo__meta_description',
                id: '69b9ad12-66e7-4b64-92ef-389ba8cb33d8',
                externalId: undefined,
                name: 'Meta Description',
                required: false,
                type: 'text',

                snippetCodename: 'seo'
            },

            /**
             * Meta Title (text)
             */
            seo__meta_title: {
                codename: 'seo__meta_title',
                id: 'f3ef17b6-0bd4-4c1f-8e16-79d66bcb6f1f',
                externalId: undefined,
                name: 'Meta Title',
                required: true,
                type: 'text',

                snippetCodename: 'seo'
            },

            /**
             * No Follow (multiple_choice)
             */
            seo__no_follow: {
                codename: 'seo__no_follow',
                id: 'f3bbb042-2cfa-4bf2-ad97-9a4756c45275',
                externalId: undefined,
                name: 'No Follow',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: 'ed0f2d7d-e5ea-43d2-8be0-5e2b62bb8733',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: 'dba27b75-0e3e-4f06-809c-1f7ea64cdb07',
                        codename: 'no',
                        externalId: undefined
                    }
                },
                snippetCodename: 'seo'
            },

            /**
             * No Index (multiple_choice)
             */
            seo__no_index: {
                codename: 'seo__no_index',
                id: '298ecfd0-51b9-4680-bb29-bb722456d928',
                externalId: undefined,
                name: 'No Index',
                required: false,
                type: 'multiple_choice',
                options: {
                    yes: {
                        name: 'Yes',
                        id: 'f70421a8-4dce-4eb4-9c8d-840a32006a86',
                        codename: 'yes',
                        externalId: undefined
                    },
                    no: {
                        name: 'No',
                        id: 'bd5bff7b-099e-4221-a1d8-0b29f3cfc696',
                        codename: 'no',
                        externalId: undefined
                    }
                },
                snippetCodename: 'seo'
            },

            /**
             * Required Query Params (modular_content)
             */
            required_query_params: {
                codename: 'required_query_params',
                id: '8346c522-8db5-4e39-897f-a0eef8b6a917',
                externalId: undefined,
                name: 'Required Query Params',
                required: false,
                type: 'modular_content'
            },

            /**
             * URL slug (url_slug)
             */
            url_slug: {
                codename: 'url_slug',
                id: 'cc0472c0-9783-452a-bce0-40500d2d3eb5',
                externalId: undefined,
                name: 'URL slug',
                required: true,
                type: 'url_slug'
            }
        }
    },

    /**
     * Table Column
     */
    table_column: {
        codename: 'table_column',
        id: 'a6ce62cb-3dd6-4d01-9ca0-b33e79e964f1',
        externalId: undefined,
        name: 'Table Column',
        elements: {
            /**
             * Alignment (multiple_choice)
             */
            alignment: {
                codename: 'alignment',
                id: '9139c827-d39e-42f2-bab6-2d86f0e78004',
                externalId: undefined,
                name: 'Alignment',
                required: false,
                type: 'multiple_choice',
                options: {
                    left: {
                        name: 'left',
                        id: 'dee18b9b-e6a8-4508-a580-0c18e6f0d422',
                        codename: 'left',
                        externalId: undefined
                    },
                    center: {
                        name: 'center',
                        id: 'f67d913c-a7ee-4d69-87a2-55bf3c7b06eb',
                        codename: 'center',
                        externalId: undefined
                    },
                    right: {
                        name: 'right',
                        id: '33d4453a-39d3-4ca2-acd7-0cb3a2d49e29',
                        codename: 'right',
                        externalId: undefined
                    }
                }
            },

            /**
             * Disable Sorting (multiple_choice)
             */
            disable_sorting: {
                codename: 'disable_sorting',
                id: 'e7d036cd-5512-48a4-993a-68b1a00a4fd8',
                externalId: undefined,
                name: 'Disable Sorting',
                required: false,
                type: 'multiple_choice',
                options: {
                    true: {
                        name: 'true',
                        id: '2f0b68f2-cf86-45dc-a1a7-b2db87d67612',
                        codename: 'true',
                        externalId: undefined
                    },
                    false: {
                        name: 'false',
                        id: 'a56d111c-9c70-4576-a3fb-acb9ec301f8a',
                        codename: 'false',
                        externalId: undefined
                    }
                }
            },

            /**
             * Id (text)
             *
             * Insert the column's id in camel case format
             */
            id: {
                codename: 'id',
                id: '5aeb7fd1-d90e-4503-8b39-12278c9302a9',
                externalId: undefined,
                name: 'Id',
                required: true,
                type: 'text'
            },

            /**
             * Label (text)
             */
            label: {
                codename: 'label',
                id: 'f26234ca-e969-4e72-a92a-5e807917c5d1',
                externalId: undefined,
                name: 'Label',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Text Item
     */
    text_item: {
        codename: 'text_item',
        id: 'e79b3b66-08ed-4e89-af63-063fa7a0fa11',
        externalId: undefined,
        name: 'Text Item',
        elements: {
            /**
             * Value (text)
             */
            value: {
                codename: 'value',
                id: '72415d74-2437-4276-afde-a76207495138',
                externalId: undefined,
                name: 'Value',
                required: false,
                type: 'text'
            }
        }
    },

    /**
     * Web Banner
     */
    web_banner: {
        codename: 'web_banner',
        id: '675ad080-6e7a-4023-bf52-8308bbc3954c',
        externalId: undefined,
        name: 'Web Banner',
        elements: {
            /**
             * Desktop Portrait Image (modular_content)
             */
            portrait_image: {
                codename: 'portrait_image',
                id: '2f2107db-607a-448e-a2c1-227c57d207f3',
                externalId: undefined,
                name: 'Desktop Portrait Image',
                required: false,
                type: 'modular_content'
            },

            /**
             * Desktop Square Image (modular_content)
             */
            window_image: {
                codename: 'window_image',
                id: 'd39af6ea-5609-41ea-bad3-f384a957f4b5',
                externalId: undefined,
                name: 'Desktop Square Image',
                required: false,
                type: 'modular_content'
            },

            /**
             * Link (modular_content)
             */
            link: {
                codename: 'link',
                id: 'd0236b7e-f286-4c5d-a05a-44666d9166d2',
                externalId: undefined,
                name: 'Link',
                required: false,
                type: 'modular_content'
            },

            /**
             * Mobile Image (modular_content)
             */
            mobile_image: {
                codename: 'mobile_image',
                id: 'd827d2b7-e2ed-49ce-a4b5-d5d582639f89',
                externalId: undefined,
                name: 'Mobile Image',
                required: false,
                type: 'modular_content'
            }
        }
    },

    /**
     * Web Banner Placeholder
     */
    web_banner_placeholder: {
        codename: 'web_banner_placeholder',
        id: '16f7d678-4caf-4dbc-90ae-13c589b17e3a',
        externalId: undefined,
        name: 'Web Banner Placeholder',
        elements: {
            /**
             * Portrait image (multiple_choice)
             */
            forced_portrait: {
                codename: 'forced_portrait',
                id: '683ccbd9-7811-4f98-9a9d-5fcaecba87bb',
                externalId: undefined,
                name: 'Portrait image',
                required: false,
                type: 'multiple_choice',
                options: {
                    true: {
                        name: 'Yes',
                        id: '3fcaaf50-0c1a-4155-b483-ba5955a86c47',
                        codename: 'true',
                        externalId: undefined
                    },
                    false: {
                        name: 'No',
                        id: '2f457a97-a4e2-4b5f-9830-7d02188b748c',
                        codename: 'false',
                        externalId: undefined
                    }
                }
            },

            /**
             * Selected web banners (modular_content)
             */
            selected_web_banners: {
                codename: 'selected_web_banners',
                id: '8e6e0fe4-98fe-4cec-929a-9ae1d55c7988',
                externalId: undefined,
                name: 'Selected web banners',
                required: false,
                type: 'modular_content'
            }
        }
    }
} as const;
